<template>
  <div>
    <!-- 服务商 -->
    <div class="detail-wrap">
      <el-form ref="editForm" :model="formData">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info" />
            退换单号：<span v-if="formData.exchangeOrderNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
              formData.exchangeOrderNo }}</span>
            <span v-else class="information"> 待生成</span>
            <!-- 状态 -->
            <span v-if="!dataId" class="information"> 新增</span>
            <span v-else class="information">

              {{
                formData.stat == '0' ? '制单' : formData.stat == '1' ? '制单' : formData.stat == '2' ? '审核中' : formData.stat ==
                  '5' ? '已审核' : formData.stat == '6' ? '驳回' : formData.stat == '99' ? '取消'  : formData.stat == '98' ? '关闭': ''
              }}
            </span>
          </div>
          <div class="fr" v-show="btn_no" v-if="showButton">
            <el-button type="primary" class="button-sty" icon="el-icon-check"
              v-if="(addButton || editButton) && (formData.stat == 1 || formData.stat == 6)"
              @click="saveData('editForm')">保存
            </el-button>
            <el-button type="primary"  class="button-sty" icon="el-icon-check"
              v-if="formData.stat == 1 && submitButton" @click="handleCommand('提交')">提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
              v-if="formData.id>0 &&  formData.stat == 1 && cancleButton"
              @click="handleCommand('取消')">取消
            </el-button>

            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id>0 && !formData.installOrderId && !isSite && formData.stat <98 && addInstallOrderButton" @click="handleCommand('一键生成安装单')">一键生成安装单
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id>0 && !formData.dismantleOrderId && !isSite && formData.stat <98 && addDismantleOrderButton" @click="handleCommand('一键生成拆机单')">一键生成拆机单
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="!isSite &&  formData.checkStat == 10 && formData.stat == 2 && canChangeModelButton" @click="handleCommand('可换机型')">可换机型
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="!isSite &&  formData.checkStat == 10 && formData.stat == 2 && canChangeModelRejectButton" @click="handleCommand('可换机型驳回')">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="!isSite &&  formData.checkStat == 20 && formData.stat == 2 && createSaleDeliveryOrderButton" @click="handleCommand('创建销售发货订单')">创建销售发货订单
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="!isSite &&  formData.checkStat == 20 && formData.stat == 2 && createSaleDeliveryOrderRejectButton" @click="handleCommand('创建销售发货订单驳回')">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="!isSite &&  formData.checkStat == 30 && formData.stat == 2 && headOfficeServiceSupportManagerApprovalButton" @click="handleCommand('总部服务支持经理审批')">总部服务支持经理审批
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="isSite &&  formData.checkStat == 40 && formData.stat == 2 && newItemReceiptButton" @click="handleCommand('新件收货')">新件收货
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="isSite && formData.checkStat == 50 && formData.stat == 2 && (!formData.returnFactoryType || formData.returnFactoryType == 1) && oldItemReturnFactoryButton" @click="handleCommand('旧件返厂')">旧件返厂
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="isSite &&  formData.checkStat == 50 && formData.stat == 2 && (!formData.returnFactoryType || formData.returnFactoryType == 2) && oldItemRecoveryButton" @click="handleCommand('旧机回收')">旧机回收
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="!isSite &&  formData.checkStat == 60 && formData.stat == 2 && headOfficeOldItemSignButton" @click="handleCommand('总部旧件签收')">旧件签收
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="!isSite &&  formData.checkStat == 70 && formData.stat == 2 && headOfficeOldItemReturnButton" @click="handleCommand('总部旧件退回')">旧件退回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="isSite &&  formData.checkStat == 80 && formData.stat == 2 && serviceProviderOldItemSignButton" @click="handleCommand('服务商旧机签收')">旧机签收
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="!isSite &&  formData.checkStat == 100 && formData.stat == 2 && qualityIdentificationButton" @click="handleCommand('品质鉴定')">品质鉴定
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="isSite &&  formData.checkStat == 110 && formData.stat == 2 && confirmExchangeWayButton" @click="handleCommand('确认结算方式')">确认结算方式
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="!isSite &&  formData.checkStat == 120 && formData.stat == 2 && headOfficeOutputExchangeSchemeButton" @click="handleCommand('总部输出折算方案')">总部输出折算方案
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="isSite &&  formData.checkStat == 130 && formData.stat == 2 && confirmExchangeSchemeButton" @click="handleCommand('确认折算方案')">确认折算方案
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id>0 && !isSite && formData.stat <98 && isRetainButton" @click="handleCommand('是否挽留')">是否挽留
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id>0 && !isSite && formData.stat <98 && endButton" @click="handleCommand('结束')">关闭
            </el-button>
          </div>
        </div>

        <div style="display: flex;height: 125vh;">
          <div class="d-cont edit-mce-box rightCs" :style="orderBlock ? 'width:80%' : 'width:99%'">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="业务信息" name="first">
          <!-- 基本信息 -->
          <dix style="overflow: unset!important;overflow-y: scroll!important;height: 80vh!important;display: block ">
            <div class="d-cont edit-mce-box" >
              <div class="d-item" style="padding-top: 10px;">
                <div class="title first"><b>基本信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        单据状态
                      </th>
                      <td>
                        <el-select v-model="formData.stat" style="width:8vw!important ;" clearable disabled>
                          <el-option label="制单" :value="1" />
                          <el-option label="审核中" :value="2" />
                          <el-option label="已审核" :value="5" />
                          <el-option label="驳回" :value="6" />
                          <el-option label="取消" :value="99" />
                          <el-option label="关闭" :value="98" />
                        </el-select>
                      </td>
                      <th>
                        <em class="f-red" >*</em>
                        申请单号
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.billNo" clearable
                                  >
                          <i slot="suffix" class="el-input__icon el-icon-search" @click="searchOrder"></i>
                        </el-input>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        机构名称
                      </th>
                      <td>
                        <el-cascader v-model="orgValue" :options="orgOptions" @change="orgHandleChange"
                          :props="{ label: 'name', value: 'id', checkStrictly: true }" style="width:8vw!important ;" :disabled="true"  />
                      </td>

                      <th>
                        <em class="f-red">*</em>
                        网点
                      </th>
                      <td v-if="justShow">{{ formData.siteName }}</td>
                      <td v-else-if="!!this.currentSiteData">
                        <el-input type="text" autocomplete="off" v-model="formData.siteName"
                          style="width:8vw!important ;" clearable :disabled="true">
                          <i slot="suffix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                      </td>
                      <td v-else>
                        <el-input type="text" autocomplete="off" v-model="formData.siteName"
                          style="width:8vw!important ;" clearable @clear="clearSite">
                          <i slot="suffix" class="el-input__icon el-icon-search" @click="showSitePop = true"></i>
                        </el-input>
                      </td>
                      <th><em class="f-red">*</em>联系人</th>
                      <td>
                        <el-input type="text" autocomplete="off" prop="siteMan" v-model="formData.siteMan"
                          style="width:8vw!important;" clearable />
                      </td>
                      <th><em class="f-red">*</em>联系人电话</th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="callMobile1" clearable
                          style="width:8vw!important;" />
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        退换原因
                      </th>
                      <td>
                        <el-select v-model="formData.exchangeReason" style="width:8vw!important ;" disabled="true" clearable>
                          <el-option v-for="item in exchangeReasonList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        退换分类
                      </th>
                      <td>
                        <el-select v-model="formData.exchangeType" style="width:8vw!important ;"  disabled="true" clearable @change="exchangeTypeChange" >
                          <el-option v-for="item in exchangeTypeList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        是否直发机
                      </th>
                      <td>
                        <el-select v-model="formData.isDirectExchange" clearable  style="width:8vw!important ;" >
                          <el-option :value="0" label="否"></el-option>
                          <el-option :value="1" label="是"></el-option>
                        </el-select>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        是否用户问题
                      </th>
                      <td>
                        <el-select v-model="formData.isUserQuestion" clearable  style="width:8vw!important ;" >
                          <el-option :value="0" label="否"></el-option>
                          <el-option :value="1" label="是"></el-option>
                        </el-select>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        问题描述
                      </th>
                      <td colspan="5">
                        <el-input type="textarea" autocomplete="off" v-model="formData.problemRemark" oninput="if(value.length>500){value=value.substring(0, 500)}"
                          style="width:49vw!important;"  clearable />
                      </td>
                    </tr>
                    <tr>
                      <th>
                        入库仓
                      </th>
                      <td>
                        <el-select v-model="formData.inWarehouseId" :disabled="able">
                          <el-option v-for="item in warehouseList" :key="item.id"
                            :label="item.warehouseName + '(' + item.warehouseCode + ')'" :value="item.id">
                          </el-option>
                        </el-select>
                      </td>
                      <th>
                        出库仓
                      </th>
                      <td>
                        <el-select v-model="formData.outWarehouseId" :disabled="able">
                          <el-option v-for="item in warehouseList" :key="item.id"
                            :label="item.warehouseName + '(' + item.warehouseCode + ')'" :value="item.id">
                          </el-option>
                        </el-select>
                      </td>
                      <th>
                        是否挽留
                      </th>
                      <td>
                        <el-select v-model="formData.isWl" disabled>
                          <el-option :value="1" label="是"></el-option>
                          <el-option :value="0" label="否"></el-option>
                        </el-select>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        返厂方式
                      </th>
                      <td>
                        <el-select v-model="formData.returnFactoryType" :disabled ="formData.stat != 1">
                          <el-option :value="1" label="旧机返厂"></el-option>
                          <el-option :value="2" label="旧机回收"></el-option>
                        </el-select>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        总部收货异常默认退回地区
                      </th>

                      <td colspan="3">
                        <el-form-item>
                          <template>
                            <el-cascader :props="areaProps" v-model="defaultReturnValues" :clearable="true" style="width:100%;"
                              @change="handleChange3" ref="cascader3" :options="defaultReturnOption">
                            </el-cascader>
                          </template>
                        </el-form-item>
                      </td>

                      <th>
                        <em class="f-red">*</em>
                        详细地址
                      </th>
                      <td colspan="3">
                        <el-input type="text"  autocomplete="off" v-model="formData.defaultReturnAddress" clearable
                           />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-item">
                <div class="title first"><b>用户信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>

                      <th>
                        <em class="f-red">*</em>
                        用户姓名
                      </th>
                      <td>
                        <el-input type="text" style="width:8vw!important;"  autocomplete="off" v-model="formData.userName" disabled="true" clearable>
                          <i slot="suffix" class="el-input__icon el-icon-search" @click="showCustProfile = true"></i>
                        </el-input>
                      </td>

                      <th>
                        <em class="f-red">*</em>
                        用户电话
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.userMobile"
                          style="width:8vw!important;" disabled="true" clearable />
                      </td>

                      <th style="visibility: hidden;"></th>
                      <td>
                      </td>

                    </tr>

                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        地区
                      </th>

                      <td colspan="3">
                        <el-form-item>
                          <template>
                            <el-cascader :props="areaProps" v-model="areaValues" :clearable="true" style="width:100%;" disabled="true"
                              @change="handleChange" ref="cascader" :options="areaOption">
                            </el-cascader>
                          </template>
                        </el-form-item>
                      </td>

                      <th>
                        <em class="f-red">*</em>
                        详细地址
                      </th>
                      <td colspan="3">
                        <el-input  type="textarea" :autosize="{ minRows: 1, maxRows: 2 }" autocomplete="off" v-model="formData.userAddress" clearable disabled="true"
                           />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-item">
                <div class="title first"><b>产品信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        产品类型
                      </th>
                      <td>
                        <el-form-item :rules="[{ required: true, trigger: 'blur' }]" class="select_input">
                          <el-select v-model="formData.bigCategoryId" placeholder="大类" @change='productSelectOne'disabled="true"
                            clearable style="width: 49%!important;">
                            <el-option v-for="item in productOptions0" :key="item.value" :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                          <el-select v-model="formData.smallCategoryId" placeholder="小类" clearable disabled="true"
                            style="width: 49%!important;margin-left:2%;">
                            <el-option v-for="item in productOptions1" :key="item.value" :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        产品编码
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.itemCode" clearable disabled="true"
                          readonly
                          style="width:8vw!important;">
                          <i slot="suffix" class="el-input__icon el-icon-search" v-if="!this.checkOrder"
                            @click="showPreconditionDialog = true"></i>
                        </el-input>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        产品名称
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.itemName" clearable disabled
                          style="width:8vw!important;">
                        </el-input>
                      </td>

                      <th>
                        <em class="f-red">*</em>
                        产品条码
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.barcode"  style="width:8vw!important;" disabled="true"
                          clearable />
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        购买金额
                      </th>
                      <td>
                        <el-input type="number" autocomplete="off" v-model="formData.buyAmount" disabled="true"
                          style="width:8vw!important;" clearable />
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        购买日期
                      </th>
                      <td>
                        <el-date-picker v-model="formData.buyDate" type="date" placeholder="选择日期" disabled="true"
                          value-format="yyyy-MM-dd 00:00:00" :picker-options="optionsDisable"
                          style="width:8vw!important;">
                        </el-date-picker>
                      </td>
                      <th>
                        气源名称
                      </th>
                      <td>
                        <el-select v-model="formData.gasType" style="width:8vw!important;" clearable disabled="true">
                          <el-option v-for="item in gasTypeList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="d-item">
                <div class="title first"><b @click="() => { showAssignDialog = true; }">附件信息</b></div>
                <table class="table-detail">
                  <tbody>
                  <tr>
                    <th><em class="f-red">*</em>故障点照片</th>
                    <td colspan="">
                      <div class="form_picture" style="width:8vw!important;">
                        <div>
                          <photo-upload :photo-url.sync="formData.sysmtomPic" :photo-show="formData.stat != 1"/>

                        </div>
                      </div>
                    </td>
                    <th><em class="f-red">*</em>安装环境图片</th>
                    <td>
                      <div style="width:8vw!important;">
                        <photo-upload :photo-url.sync="formData.installPic" :photo-show="formData.stat != 1"/>

                      </div>
                    </td>

                    <th><em class="f-red">*</em>铭牌信息图片</th>
                    <td>
                      <div style="width:8vw!important;">
                        <photo-upload :photo-url.sync="formData.labelPic" :photo-show="formData.stat != 1"/>

                      </div>
                    </td>

                    <th><em class="f-red">*</em>产品条码图片</th>
                    <td>
                      <div style="width:8vw!important;">
                        <photo-upload :photo-url.sync="formData.barcodePic" :photo-show="formData.stat != 1"/>

                      </div>
                    </td>
                  </tr>
                  <tr>

                    <th><em class="f-red">*</em>视频</th>
                    <td>
                      <div style="width:8vw!important;">
                        <td style="padding-left: 0!important;">
                          <div style="display: flex;">
                            <div @click="uploadVideo" class="videoAdd"> <i class="el-icon-plus"></i></div>

                            <div class="videoP" v-if="formData.vedioUrl">

                              <div style="width:40%;    position: relative;" class="videoImg">
                                <el-image style="width: 30px; height: 35px"
                                          :src="require('@/views/dialogCommon/video.jpg')" fit="fit"></el-image>
                                <div @click="openVideo(formData.vedioUrl)" class="imgY"><i class="el-icon-video-play"></i></div>
                              </div>

                              <div style="width:50%;display:flex;    flex-direction: column;justify-content: space-between;align-items: flex-end;">
                                <span>{{formData.vedioName}}</span>
                                <div @click="handleDownload(formData.vedioName,formData.vedioUrl)">
                                  <el-tooltip class="item" effect="dark" content="下载" placement="top">
                                    <i class="el-icon-download"></i>
                                  </el-tooltip>
                                </div>
                              </div>

                            </div>
                          </div>

                        </td>
                      </div>
                    </td>

                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </dix>
            </el-tab-pane>
            <el-tab-pane label="收货信息" name="second">
              <!-- 基本信息 -->
              <dix style="overflow: unset!important;overflow-y: scroll!important;height: 100vh!important;display: block ">
                <div class="d-cont edit-mce-box" >
              <div class="d-item">
                <div class="title first"><b>收货人信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        姓名
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.receiveMan" :disabled="formData.stat>1"
                          style="width:8vw!important;" clearable />
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        联系方式
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.receiveMobile" :disabled="formData.stat>1"
                          style="width:8vw!important;" clearable />
                      </td>
                      <th style="visibility: hidden;"></th>
                          <td>  <el-input type="text" style="visibility: hidden;width:8vw!important;"  autocomplete="off" v-model="formData.userName" clearable>
                        </el-input></td>
                          <th style="visibility: hidden;"></th>
                          <td>  <el-input type="text" style="visibility: hidden;width:8vw!important;"  autocomplete="off" v-model="formData.userName" clearable>
                        </el-input></td>
                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        收货地址
                      </th>
                      <td colspan="3">
                        <el-form-item>
                          <template>
                            <el-cascader :props="areaProps" v-model="receiveAreaValues" :clearable="true"
                              style="width:100%;" :disabled="formData.stat>1" @change="handleChange2" ref="cascader2"
                              :options="receiveAreaOption">
                            </el-cascader>
                            <!-- :disabled="able" -->
                          </template>
                        </el-form-item>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        详细地址
                      </th>
                      <td colspan="3">
                        <el-input type="text" autocomplete="off" v-model="formData.receiveAddress" :disabled="formData.stat>1"
                           clearable />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
                </div>
              </dix>
            </el-tab-pane>
            <el-tab-pane label="物流信息" name="three">
              <dix style="overflow: unset!important;overflow-y: scroll!important;height: 100vh!important;display: block ">
                <div class="d-cont edit-mce-box" >
              <div class="d-item">
                <div class="title first"><b>物流信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        旧机退货状态
                      </th>
                      <td>
                        <el-select v-model="formData.returnLogisticsStat" style="width:8vw!important;" :disabled="able"
                          clearable>
                          <el-option label="未发货" :value="0" />
                          <el-option label="已发货" :value="2" />
                          <el-option label="已签收" :value="5" />
                        </el-select>
                      </td>

                      <th>
                        退货物流公司名称
                      </th>
                      <td>
                        <el-select v-model="formData.returnLogisticsCompany" style="width:8vw!important;"
                          :disabled="able" clearable>
                          <el-option v-for="item in logisticsCompaniesList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </td>


                      <th>旧机返厂单号</th>
                      <td>
                        <span v-if="formData.returnLogisticsNo != null && formData.returnLogisticsNo != 0"
                              style="color: blue; cursor:pointer;" @click="showDeliverNo(formData.returnLogisticsNo,formData.returnLogisticsCompanyName,formData.receiveMobile)">
                                    {{ formData.returnLogisticsNo }}
                                </span>
                        <el-input type="text" autocomplete="off" v-model="formData.returnLogisticsNo" :disabled="able"
                          style="width:8vw!important;" clearable />
                      </td>
                      <th>退货签收时间</th>
                      <td>
                        <el-date-picker v-model="formData.returnLogisticsSign" type="datetime" placeholder="选择日期时间"
                          :disabled="able" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                          style="width:8vw!important;">
                        </el-date-picker>
                      </td>

                    </tr>
                    <tr>
                      <th>
                        新机返还状态</th>
                      <td>
                        <el-select v-model="formData.backLogisticsStat" style="width:8vw!important;" :disabled="able"
                          clearable>
                          <el-option label="未发货" :value="0" />
                          <el-option label="已发货" :value="2" />
                          <el-option label="已签收" :value="5" />
                        </el-select>
                      </td>

                      <th>
                        返还物流公司名称
                      </th>
                      <td>
                        <el-select v-model="formData.backLogisticsCompany" style="width:8vw!important;" :disabled="able"
                          clearable>
                          <el-option v-for="item in logisticsCompaniesList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </td>
<!--                      <th>-->
<!--                        新机物流单号</th>-->
<!--                      <td><el-input type="text" autocomplete="off" v-model="formData.backLogisticsNo" :disabled="able"-->
<!--                          clearable /></td>-->

                      <th>
                        新机物流单号</th>
                      <td>
                        <span v-if="formData.backLogisticsNo != null && formData.backLogisticsNo != 0"
                              style="color: blue; cursor:pointer;" @click="showDeliverNo(formData.backLogisticsNo,formData.backLogisticsCompanyName,formData.receiveMobile)">
                                    {{ formData.backLogisticsNo }}
                                </span>
                        <el-input type="text" autocomplete="off" v-model="formData.backLogisticsNo" :disabled="able"
                                  clearable /></td>

                      <th>返还签收时间</th>
                      <td>
                        <el-date-picker v-model="formData.backLogisticsSign" type="datetime" placeholder="选择日期时间"
                          :disabled="able" value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        总部旧机退回状态</th>
                      <td>
                        <el-select v-model="formData.zbBackLogisticsStat" style="width:8vw!important;" :disabled="able"
                                   clearable>
                          <el-option label="未发货" :value="0" />
                          <el-option label="已发货" :value="2" />
                          <el-option label="已签收" :value="5" />
                        </el-select>
                      </td>

                      <th>
                        总部旧机退回物流公司名称
                      </th>
                      <td>
                        <el-select v-model="formData.zbBackLogisticsCompany" style="width:8vw!important;" :disabled="able"
                                   clearable>
                          <el-option v-for="item in logisticsCompaniesList" :key="item.value" :label="item.label"
                                     :value="item.value">
                          </el-option>
                        </el-select>
                      </td>
                      <th>
                        总部旧机退回单号</th>
                      <td>
                        <span v-if="formData.zbBackLogisticsNo != null && formData.zbBackLogisticsNo != 0"
                              style="color: blue; cursor:pointer;" @click="showDeliverNo(formData.zbBackLogisticsNo,formData.zbBackLogisticsCompanyName,formData.receiveMobile)">
                                    {{ formData.zbBackLogisticsNo }}
                                </span>
                        <el-input type="text" autocomplete="off" v-model="formData.zbBackLogisticsNo" :disabled="able"
                                    clearable /></td>
                      <th>总部旧机退回签收时间</th>
                      <td>
                        <el-date-picker v-model="formData.zbBackLogisticsSign" type="datetime" placeholder="选择日期时间"
                                        :disabled="able" value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        备注
                      </th>
                      <td colspan="7">
                        <el-input type="text" autocomplete="off" v-model="formData.remark" :disabled="able"
                           />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
                </div>
              </dix>
            </el-tab-pane>
            <el-tab-pane label="接口对接" name="four">
              <!-- 基本信息 -->
              <dix style="overflow: unset!important;overflow-y: scroll!important;height: 100vh!important;display: block ">
                <div class="d-cont edit-mce-box" >
                  <div class="d-item">
                    <div class="title first"><b>接口对接</b></div>
                        <table class="table-detail">
                          <tbody>
                          <tr>
                            <th>
                              ERP销售传单备注
                            </th>
                            <td>
                              <el-input v-model="formData.send1Message" :disabled="able" placeholder="传单备注"></el-input>
                            </td>
                            <th>
                              ERP销售传单状态
                            </th>
                            <td>
                              <el-select v-model="formData.send1Flag" clearable :disabled="able" style="width:8vw!important;">
                                <el-option :value="0" label="未传"></el-option>
                                <el-option :value="1" label="失败"></el-option>
                                <el-option :value="2" label="已传"></el-option>
                              </el-select>
                            </td>
                            <th>
                              ERP销售对接单号
                            </th>
                            <td>
                              <el-input autocomplete="off" v-model="formData.send1No" :disabled="able"
                                        placeholder="对接单号"></el-input>
                            </td>
                            <th>
                              ERP客户编码
                            </th>
                            <td>
                              <el-input autocomplete="off" v-model="formData.erpCustCode" :disabled="able"
                                        placeholder="ERP客户编码"></el-input>
                            </td>
                          </tr>
                          <tr>
                            <th>
                              WMS锁库传单备注
                            </th>
                            <td>
                              <el-input v-model="formData.send2Message" :disabled="able" placeholder="传单备注"></el-input>
                            </td>
                            <th>
                              WMS锁库传单状态
                            </th>
                            <td>
                              <el-select v-model="formData.send2Flag" clearable :disabled="able" style="width:8vw!important;">
                                <el-option :value="0" label="未传"></el-option>
                                <el-option :value="1" label="失败"></el-option>
                                <el-option :value="2" label="已传"></el-option>
                              </el-select>
                            </td>
                            <th>
                              WMS锁库对接单号
                            </th>
                            <td>
                              <el-input v-model="formData.send2No" :disabled="able" placeholder="对接单号"></el-input>
                            </td>
                          </tr>
                          <tr>
                            <th>
                              ERP交货传单备注
                            </th>
                            <td>
                              <el-input v-model="formData.send3Message" :disabled="able" placeholder="传单备注"></el-input>
                            </td>
                            <th>
                              ERP交货传单状态
                            </th>
                            <td>
                              <el-select v-model="formData.send3Flag" clearable :disabled="able" style="width:8vw!important;">
                                <el-option :value="0" label="未传"></el-option>
                                <el-option :value="1" label="失败"></el-option>
                                <el-option :value="2" label="已传"></el-option>
                              </el-select>
                            </td>
                            <th>
                              ERP交货对接单号
                            </th>
                            <td>
                              <el-input v-model="formData.send3No" :disabled="able" placeholder="对接单号"></el-input>
                            </td>
                          </tr>
                          <tr>
                            <th>
                              WMS出库传单备注
                            </th>
                            <td>
                              <el-input v-model="formData.send4Message" :disabled="able" placeholder="传单备注"></el-input>
                            </td>
                            <th>
                              WMS出库传单状态
                            </th>
                            <td>
                              <el-select v-model="formData.send4Flag" clearable :disabled="able" style="width:8vw!important;">
                                <el-option :value="0" label="未传"></el-option>
                                <el-option :value="1" label="失败"></el-option>
                                <el-option :value="2" label="已传"></el-option>
                              </el-select>
                            </td>
                            <th>
                              WMS出库对接单号
                            </th>
                            <td>
                              <el-input v-model="formData.send4No" :disabled="able" placeholder="对接单号"></el-input>
                            </td>
                          </tr>
                          <tr>
                            <th>
                              ERP退货传单备注
                            </th>
                            <td>
                              <el-input v-model="formData.send5Message" :disabled="able" placeholder="传单备注"></el-input>
                            </td>
                            <th>
                              ERP退货传单状态
                            </th>
                            <td>
                              <el-select v-model="formData.send5Flag" clearable :disabled="able" style="width:8vw!important;">
                                <el-option :value="0" label="未传"></el-option>
                                <el-option :value="1" label="失败"></el-option>
                                <el-option :value="2" label="已传"></el-option>
                              </el-select>
                            </td>
                            <th>
                              ERP退货对接单号
                            </th>
                            <td>
                              <el-input v-model="formData.send5No" :disabled="able" placeholder="对接单号"></el-input>
                            </td>
                          </tr>
                          <tr>
                            <th>
                              ERP交货(退)传单备注
                            </th>
                            <td>
                              <el-input v-model="formData.send6Message" :disabled="able" placeholder="传单备注"></el-input>
                            </td>
                            <th>
                              ERP交货(退)传单状态
                            </th>
                            <td>
                              <el-select v-model="formData.send6Flag" clearable :disabled="able" style="width:8vw!important;">
                                <el-option :value="0" label="未传"></el-option>
                                <el-option :value="1" label="失败"></el-option>
                                <el-option :value="2" label="已传"></el-option>
                              </el-select>
                            </td>
                            <th>
                              ERP交货(退)对接单号
                            </th>
                            <td>
                              <el-input v-model="formData.send6No" :disabled="able" placeholder="对接单号"></el-input>
                            </td>
                          </tr>
                          <tr>
                            <th>
                              WMS入库传单备注
                            </th>
                            <td>
                              <el-input v-model="formData.send7Message" :disabled="able" placeholder="传单备注"></el-input>
                            </td>
                            <th>
                              WMS入库传单状态
                            </th>
                            <td>
                              <el-select v-model="formData.send7Flag" clearable :disabled="able" style="width:8vw!important;">
                                <el-option :value="0" label="未传"></el-option>
                                <el-option :value="1" label="失败"></el-option>
                                <el-option :value="2" label="已传"></el-option>
                              </el-select>
                            </td>
                            <th>
                              WMS入库对接单号
                            </th>
                            <td>
                              <el-input v-model="formData.send7No" :disabled="able" placeholder="对接单号"></el-input>
                            </td>
                          </tr>
                          <tr>
                            <th>
                              WMS取消传单备注
                            </th>
                            <td>
                              <el-input v-model="formData.send8Message" :disabled="able" placeholder="传单备注"></el-input>
                            </td>
                            <th>
                              WMS取消传单状态
                            </th>
                            <td>
                              <el-select v-model="formData.send8Flag" clearable :disabled="able" style="width:8vw!important;">
                                <el-option :value="0" label="未传"></el-option>
                                <el-option :value="1" label="失败"></el-option>
                                <el-option :value="2" label="已传"></el-option>
                              </el-select>
                            </td>
                            <th>
                              WMS取消对接单号
                            </th>
                            <td>
                              <el-input v-model="formData.send8No" :disabled="able" placeholder="对接单号"></el-input>
                            </td>
                          </tr>
                          <tr>
                            <th>
                              冲账对接备注
                            </th>
                            <td>
                              <el-input v-model="formData.send9Message" :disabled="able" placeholder="传单备注"></el-input>
                            </td>
                            <th>
                              冲账对接状态
                            </th>
                            <td>
                              <el-select v-model="formData.send9Flag" clearable :disabled="able" style="width:8vw!important;">
                                <el-option :value="0" label="未传"></el-option>
                                <el-option :value="1" label="失败"></el-option>
                                <el-option :value="2" label="已传"></el-option>
                              </el-select>
                            </td>
                            <th>
                              冲账对接单号
                            </th>
                            <td>
                              <el-input v-model="formData.send9No" :disabled="able" placeholder="对接单号"></el-input>
                            </td>
                          </tr>
                          <tr>
                            <th>
                              追款对接备注
                            </th>
                            <td>
                              <el-input v-model="formData.send10Message" :disabled="able" placeholder="传单备注"></el-input>
                            </td>
                            <th>
                              追款传单状态
                            </th>
                            <td>
                              <el-select v-model="formData.send10Flag" clearable :disabled="able" style="width:8vw!important;">
                                <el-option :value="0" label="未传"></el-option>
                                <el-option :value="1" label="失败"></el-option>
                                <el-option :value="2" label="已传"></el-option>
                              </el-select>
                            </td>
                            <th>
                              追款对接单号
                            </th>
                            <td>
                              <el-input v-model="formData.send10No" :disabled="able" placeholder="对接单号"></el-input>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                  </div>
                </div>
              </dix>
            </el-tab-pane>
            <el-tab-pane label="返还产品" name="five">
              <dix style="overflow: unset!important;overflow-y: scroll!important;height: 100vh!important;display: block ">
                <div class="d-cont edit-mce-box" >
                  <div class="d-item">
                    <div>
                      <div class="title first" style="display: flex;align-items: center;">
                        <b>返还产品</b>
<!--                        <div class="item-button" style="margin-top: 8px;">-->
<!--                          <el-button type="primary" class="button-sty btn_zdy" @click="ableShowMulPreconditionDialog">-->
<!--                            <i class="el-icon-plus"></i>-->
<!--                            添加明细-->
<!--                          </el-button>&nbsp;-->
<!--                          <el-button type="primary" class="button-sty btn_zdy" @click="deleteItemData">-->
<!--                            <i class="el-icon-delete"></i>-->
<!--                            批量删除-->
<!--                          </el-button>-->
<!--                        </div>-->

                        <div class="amount" v-if="!isSite" ><span>返还金额：{{ formData.backAmount }}</span>
                          <span style="margin-left: 50px;">差额：{{
                              formData.differenceAmount }}</span>
                        </div>

                      </div>
                    </div>
                    <div>
                      <vxe-table style="margin-top: 5px;" :stripe="true"
                                 :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '80%' }"
                                 :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                                 show-overflow height="110" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"
                                 @checkbox-all="selectChangeEvent" :data="formData.exchangeOrderBackDTOS">
                        <vxe-column type="checkbox" width="40" />
                        <vxe-column field="itemCode" title="产品编码" width="250"></vxe-column>
                        <vxe-column field="itemName" title="产品名称" width="250"></vxe-column>
                        <vxe-column field="bigCategoryName" title="产品大类" width="150"></vxe-column>
                        <vxe-column field="smallCategoryName" title="产品小类" width="150"></vxe-column>
                        <vxe-column field="qty" title="数量" width="150">
                          <template #default="{ row }">
                            <vxe-input size="small" v-model="row.qty" type="number" min="1" max="1000"
                                       :clearable="false"></vxe-input>
                            <span>{{ row.qty }}</span>
                          </template>
                        </vxe-column>
                        <vxe-column field="price" title="单价" v-if="!isSite" width="150"></vxe-column>
                        <vxe-column field="amount" title="金额" v-if="!isSite" width="150"></vxe-column>
                        <vxe-column field="barcode" title="条码" v-if="!isSite" width="150"></vxe-column>
                      </vxe-table>
                    </div>
                  </div>


                </div>
              </dix>
            </el-tab-pane>
            <el-tab-pane label="关联工单" name="six">
              <dix style="overflow: unset!important;overflow-y: scroll!important;height: 100vh!important;display: block ">
                <div class="d-cont edit-mce-box" >
                  <div class="d-item">
                      <div class="title first" style="display: flex;align-items: center;">
                      <vxe-table style="margin-top: 5px;" :stripe="true"
                                 :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '80%' }"
                                 :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                                 show-overflow height="110" :column-config="{ resizable: true }"  :data="formData.orderList">
                        <vxe-column field="serviceTypeName" title="单据类型" width="250"></vxe-column>
                        <vxe-column field="orderNo" title="单据号" width="250"></vxe-column>
                        <vxe-column field="createTime" title="创建时间" width="150"></vxe-column>
                        <vxe-column field="smallCategoryName" title="状态" width="150">
                          <template #default="{row}">
                            <span  v-if="row.stat == 1">{{$t('common.SignIn')}}</span>
                            <span  v-else-if="row.stat == 2">{{$t('common.publish')}}</span>
                            <span  v-else-if="row.stat == 3">{{$t('common.FreezePendingDispatch')}}</span>
                            <span  v-else-if="row.stat == 5">{{$t('common.DispatchedNetwork')}}</span>
                            <span  v-else-if="row.stat == 6">{{$t('common.TheNetworkReceivedOrders')}}</span>
                            <span  v-else-if="row.stat == 9">{{$t('common.DispatchedMaster')}}</span>
                            <span  v-else-if="row.stat == 10">{{$t('common.MasterHasAcceptedOrder')}}</span>
                            <span  v-else-if="row.stat == 11">{{$t('common.HaveAlreadyReserved')}}</span>
                            <span  v-else-if="row.stat == 13">{{$t('common.HaveSetOut')}}</span>
                            <span  v-else-if="row.stat == 17">{{$t('common.HaveBeenDoor')}}</span>
                            <span  v-else-if="row.stat == 20">{{$t('common.CompletedTemporaryHold')}}</span>
                            <span  v-else-if="row.stat == 30">{{$t('common.ShippingRepairConfirmed')}}</span>
                            <span  v-else-if="row.stat == 31">{{$t('common.ToBeSent')}}</span>
                            <span  v-else-if="row.stat == 32">{{$t('common.HasBeenSignature')}}</span>
                            <span  v-else-if="row.stat == 36">{{$t('common.ToBeRepaired')}}</span>
                            <span  v-else-if="row.stat == 37">{{$t('common.RepairedToShip')}}</span>
                            <span  v-else-if="row.stat == 38">{{$t('common.CustomerToBeSigned')}}</span>
                            <span  v-else-if="row.stat == 40">{{$t('common.ReturnTBeConfirmed')}}</span>
                            <span  v-else-if="row.stat == 41">{{$t('common.OldMachineReturned')}}</span>
                            <span  v-else-if="row.stat == 42">{{$t('common.OldMachineSigned')}}</span>
                            <span  v-else-if="row.stat == 43">{{$t('common.TheOldMachineSigned')}}</span>
                            <span  v-else-if="row.stat == 44">{{$t('common.NewMachinesShipped')}}</span>
                            <span  v-else-if="row.stat == 45">{{$t('common.NewMachinesSent')}}</span>
                            <span  v-else-if="row.stat == 47">{{$t('common.NewMachineTSigned')}}</span>
                            <span  v-else-if="row.stat == 48">{{$t('common.TheMachineSignedFor')}}</span>
                            <span  v-else-if="row.stat == 49">{{$t('common.TheExchangeRejected')}}</span>
                            <span  v-else-if="row.stat == 61">{{$t('common.completed')}}</span>
                            <span  v-else-if="row.stat == 62">{{$t('common.NetworkConfirmationCompletion')}}</span>
                            <span  v-else-if="row.stat == 63">{{$t('common.CenterCompletionAudit')}}</span>
                            <span  v-else-if="row.stat == 64">{{$t('common.HeadquartersCompletionAudit')}}</span>
                            <span  v-else-if="row.stat == 91">{{$t('common.ToBeSettled')}}</span>
                            <span  v-else-if="row.stat == 92">{{$t('common.RejectionSettlement')}}</span>
                            <span  v-else-if="row.stat == 93">{{$t('common.SettlementSuspension')}}</span>
                            <span  v-else-if="row.stat == 94">{{$t('common.HaveAlreadySettled')}}</span>
                            <span  v-else-if="row.stat == 96">{{$t('common.ApplyForHangUp')}}</span>
                            <span  v-else-if="row.stat == 97">{{$t('common.ApplyForClosure')}}</span>
                            <span  v-else-if="row.stat == 98">{{$t('common.HangUp')}}</span>
                            <span  v-else-if="row.stat == 99">{{$t('common.cancel')}}</span>
                            <span  v-else-if="row.stat == 100">{{$t('common.finish')}}</span>
                            <span  v-else></span>
                          </template>
                        </vxe-column>
                        <vxe-column field="createBy" title="创建人"  width="150"></vxe-column>
                      </vxe-table>
                    </div>
                    <!-- </el-collapse-item>
                        </el-collapse> -->
                  </div>

                </div>
              </dix>
            </el-tab-pane>
            <el-tab-pane label="鉴定&处理方案" name="seven">
              <dix style="overflow: unset!important;overflow-y: scroll!important;height: 100vh!important;display: block ">
                <div class="d-cont edit-mce-box" >

              <div class="d-item">

                <div class="title first"><b>鉴定信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        质量鉴定
                      </th>
                      <td>
                        <el-select v-model="formData.qualityIdentify" style="width:8vw!important;" :disabled="able"
                          clearable>
                          <el-option v-for="item in qualityIdentifyList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </td>
                      <th>
                        鉴定结果
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.identifyResultName" :disabled="able" />
                      </td>
                      <th>
                        责任鉴定
                      </th>
                      <td>
                        <el-select v-model="formData.responsibilityIdentify" style="width:8vw!important;"
                          :disabled="able" clearable>
                          <el-option v-for="item in responsibilityIdentifyList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </td>
                      <th>
                        是否可维修
                      </th>
                      <td>
                        <el-select v-model="formData.canFix" clearable :disabled="able" style="width:8vw!important;">
                          <el-option :value="0" label="否"></el-option>
                          <el-option :value="1" label="是"></el-option>
                        </el-select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-item">
                <div>
                  <div class="title first"><b>处理方案</b></div>
                  <table class="table-detail">
                    <tbody>
                      <tr>
                        <th>
                          处理方案名称
                        </th>
                        <td>
                          <el-select v-model="formData.dealWay" style="width:8vw!important;" :disabled="able" clearable>
                            <el-option v-for="item in dealWayList" :key="item.value" :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </td>
                        <th v-if="!isSite">
                          系统建议方案
                        </th>
                        <td v-if="!isSite"><el-input type="text" autocomplete="off" v-model="formData.systemSuggestDeal" :disabled="able"
                            style="width: 27vw!important;" clearable :disable="true" />
                        </td>

                      </tr>
                    <tr>
                      <th>
                        人工确认方案
                      </th>
                      <td><el-input type="text" autocomplete="off" v-model="formData.confirmWay" :disabled="able"
                                    style="width: 27vw!important;" clearable :disable="true" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
                </div>
              </dix>
            </el-tab-pane>

          </el-tabs>
          </div>
          <div :style="orderBlock ? 'width:20%' : 'width:1%'" class="bread">
            <div style="padding-bottom: 90px; height: 100%; margin-top: 10px; margin-left: 5px;">
              <div style="display: flex;">

                <div class="title_icon" @click="orderBlock = !orderBlock"><i class="el-icon-date"></i></div>
                <span :style="orderBlock ? 'display:block' : 'display:none'">申请过程</span>
              </div>
              <el-timeline :style="orderBlock ? 'display:block' : 'display:none'" class="card_bread">

                <el-timeline-item v-for="item in formData.operationsDtoList" placement="top">
                  <div class="title_time"><span class="span1"> {{ item.title }}</span>
                    <span class="span2">{{ item.createTime }}</span>
                  </div>
                  <div style="font-size: 13px;margin-top: 7px;"><span style="color: #2a6494 !important;">操作人:{{
                      item.createBy }} </span></div>
                  <el-card class="card">
                    <p>{{ item.content }}</p>
                  </el-card>
                </el-timeline-item>

              </el-timeline>

            </div>
          </div>
        </div>

    </el-form>
    <!-- 服务区域弹窗表 -->
  </div>
  <sitePop v-if="showSitePop" @commit="siteCommit" :visiable.sync="showSitePop" multi="true" />
  <!-- 视频上传 -->
  <videoDialog v-if="showVideo" @commitVideo="commitVideo" :visiable.sync="showVideo" multi="true" />

  <exchangeBillDialog v-if="showExchangeBillDialog" @commit="exchangeBillCommit" :visiable.sync="showExchangeBillDialog"  :siteId="formData.siteId" multi="true" />


<!--  <custProfileDialog v-if="showCustProfile" @commit="custProfileCommit" :visiable.sync="showCustProfile" multi="true" />-->

<!--  <warehousePop v-if="showWarehousePop" :warehouseType="warehouseType" @commit="warehouseCommit"-->
<!--    :visiable.sync="showWarehousePop" multi="true" />-->

<!--  <partsInvPop v-if="showPartsInvPop" @confirm="confirm" :visiable.sync="showPartsInvPop"-->
<!--    :warehouseId="formData.outWarehouseId" :list="formData.spPartsApplyLineDTOList" multi="true" />-->

<!--  &lt;!&ndash; 产品弹窗 &ndash;&gt;-->
<!--  <preconditionDialog v-if="showPreconditionDialog" @commitSelectedRow="commitSelectedRow" :param="{exchangeShow:1}"-->
<!--    :visiable.sync="showPreconditionDialog" multi="true" />-->
<!--  &lt;!&ndash; 产品弹窗 &ndash;&gt;-->
<!--  <preconditionDialog v-if="showMulPreconditionDialog" @commitSelectedRow="commitMulSelectedRow"-->
<!--    :visiable.sync="showMulPreconditionDialog"-->
<!--    :param="{ excludeItemIds: this.formData.backList.map(item => item.itemId) }" multi="true" />-->
<!--  &lt;!&ndash; 可换机型处理 &ndash;&gt;-->
<!--  <zhiPaiDialog v-if="showAssignDialog" :visiable.sync="showAssignDialog" @confirm="commitSelectedRow1" :bigS="bigS"-->
<!--    :excludeList="siteName" />-->
<!--        &lt;!&ndash; 文件预览 &ndash;&gt;-->
<!--        <Preview v-if="showPreview" @closeD="closeD33" :visiable.sync="showPreview" :imgVisbleURL="imgVisbleURL" />-->


    <chooseItemDialog v-if="showChooseItemDialog" @commit="chooseItems"
                      :visiable.sync="showChooseItemDialog" :chooseItemParams="chooseItemParams"></chooseItemDialog>

    <commentDraw v-if="showCommentDraw" @closeDraw="closeDraw"
                 :visiable.sync="showCommentDraw" :rejectType="rejectType"
                 :commentDrawTitle="commentDrawTitle" :exchangeOrderId="exchangeOrderId"></commentDraw>
    <oldItemRecoveryDialog v-if="showOldItemRecoveryDialog" @closeDialog="closeDialog"
                           :visiable.sync="showOldItemRecoveryDialog" :exchangeOrderNo ="exchangeOrderNo"
                           :exchangeOrderId="exchangeOrderId"></oldItemRecoveryDialog>
    <oldItemReturnDialog v-if="showOldItemReturnDialog" @closeDialog="closeDialog"
                         :visiable.sync="showOldItemReturnDialog" :exchangeOrderNo ="exchangeOrderNo" :obj="exchangeOrderObj"
                         :exchangeOrderId="exchangeOrderId"></oldItemReturnDialog>
    <zbOldItemReturnDialog v-if="showZbOldItemReturnDialog" @closeDialog="closeDialog"
                           :visiable.sync="showZbOldItemReturnDialog" :exchangeOrderNo ="exchangeOrderNo"
                           :exchangeOrderId="exchangeOrderId"></zbOldItemReturnDialog>
    <quantityCheckDialog v-if="showQuantityCheckDialog" @closeDialog="closeDialog"
                         :visiable.sync="showQuantityCheckDialog" :exchangeOrderNo ="exchangeOrderNo"
                         :exchangeOrderId="exchangeOrderId"></quantityCheckDialog>

    <schemeEntryDialog v-if="showSchemeEntryDialog" @closeDialog="closeDialog"
                       :visiable.sync="showSchemeEntryDialog" :exchangeOrderNo ="exchangeOrderNo"
                       :exchangeOrderId="exchangeOrderId"></schemeEntryDialog>

    <logistics-information-info-dialog v-if="showLogisticsInformationInfoDialog"
                                       :visiable.sync="showLogisticsInformationInfoDialog"
                                       :formData="logisticsInformationInfo"
    />
    <isWlDialog v-if="showIsWl" @closeDialog="closeDialog"
                :visiable.sync="showIsWl" :exchangeOrderNo ="exchangeOrderNo"
                :exchangeOrderId="exchangeOrderId"></isWlDialog>
  </div>
</template>

<script>
import store from "@/store";
import api from "@/api/projectApi";
import { echoFileFormat, uploadFileFormat } from "@/util/uploadFormat";
import sitePop from '@/views/dialogCommon/radioSiteDialog.vue'
import videoDialog from '@/views/dialogCommon/videoDialog.vue'

import exchangeBillDialog from './exchangeBillDialog.vue'
// import custProfileDialog from '@/views/dialogCommon/custProfileListDialog.vue'
// import warehousePop from '@/views/dialogCommon/radioWarehouseDialog.vue'
import { dictType, loadDictData } from "@/config/dictType";
// import partsInvPop from '@/views/dialogCommon/partsInvDialog.vue';
import { siteMixins } from "@/mixins/tabChang";

// 产品弹窗
// import preconditionDialog from '@/views/dialogCommon/chanPinDialog.vue';
import { fetchTree, fetchTree2 } from "@/api/admin/type_tree";
import { mapGetters } from "vuex";
import chooseItemDialog from "@/views/expense/exchange/order/chooseItemDialog.vue";
import commentDraw from "@/views/expense/exchange/order/commentOperationDialog.vue";
import oldItemReturnDialog from "@/views/expense/exchange/order/oldItemReturnDialog.vue";
import oldItemRecoveryDialog from "@/views/expense/exchange/order/oldItemRecoveryDialog.vue";
import zbOldItemReturnDialog from "@/views/expense/exchange/order/zbOldItemReturnDialog.vue";
import quantityCheckDialog from "@/views/expense/exchange/order/qualityCheck.vue";
import schemeEntryDialog from "@/views/expense/exchange/order/schemeEntry.vue";
import LogisticsInformationInfoDialog from "@/views/accessories/applyFor/apply/logisticsInformationInfoDialog.vue";
//可换机型处理
// import zhiPaiDialog from '../apply/assignSiteDialog.vue';
// // 图片
import PhotoUpload from "@/components/formItem/photoUpload.vue";
// 文件预览
// import Preview from "@/views/dialogCommon/PreviewDialog.vue";
import isWlDialog from './isWlDialog.vue'
export default {
  mixins: [siteMixins],
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    processId: [String, Number],
    btn_no: {
      type: Boolean,
      default: true
    },

    type: String
  },

  components: {
    LogisticsInformationInfoDialog,
    // Preview,
    PhotoUpload,
    exchangeBillDialog,  sitePop,
    videoDialog,
    // warehousePop, partsInvPop, preconditionDialog, custProfileDialog, zhiPaiDialog
    chooseItemDialog,commentDraw,oldItemReturnDialog,oldItemRecoveryDialog,
    zbOldItemReturnDialog,quantityCheckDialog,schemeEntryDialog,isWlDialog
  },
  data() {
    return {
      showButton:false,
      //提交
      submitButton: false,
      //取消
      cancleButton: false,
      //一键生成安装单
      addInstallOrderButton: false,
      //一键生成拆机单
      addDismantleOrderButton: false,
      //可换机型
      canChangeModelButton: false,
      //可换机型驳回
      canChangeModelRejectButton: false,
      //创建销售发货订单
      createSaleDeliveryOrderButton: false,
      //创建销售发货订单驳回
      createSaleDeliveryOrderRejectButton: false,
      //总部服务支持经理审批
      headOfficeServiceSupportManagerApprovalButton: false,
      //新件收货
      newItemReceiptButton: false,
      //旧件返厂
      oldItemReturnFactoryButton: false,
      //旧机回收
      oldItemRecoveryButton: false,
      //总部旧件签收
      headOfficeOldItemSignButton: false,
      //总部旧件退回
      headOfficeOldItemReturnButton: false,
      //服务商旧机签收
      serviceProviderOldItemSignButton: false,
      //品质鉴定
      qualityIdentificationButton: false,
      //确认折算方式
      confirmExchangeWayButton: false,
      //总部输出折算方案
      headOfficeOutputExchangeSchemeButton: false,
      //确认折算方案
      confirmExchangeSchemeButton: false,
      //是否挽留
      isRetainButton: false,
      //结束
      endButton: false,
      logisticsInformationInfo:{},
      showLogisticsInformationInfoDialog:false,
      rejectType:null,
      commentDrawTitle:null,
      exchangeOrderId:null,
      exchangeOrderObj:{},
      showCommentDraw:false,
      showOldItemReturnDialog:false,
      showOldItemRecoveryDialog:false,
      showZbOldItemReturnDialog:false,
      showQuantityCheckDialog:false,
      showSchemeEntryDialog:false,
      exchangeOrderNo:null,
      chooseItemParams:{},
      showChooseItemDialog:false,
      showIsWl:false,

      activeName: 'first',
      showExchangeBillDialog:false,
      orderBlock:true,
      operationDTOList:[],
      isZd:true,
      imgVisbleURL: '',
      basKnowledgeAdd: false,
      showPreview: false,
      // 查询参数
      queryParams: {
        deptName: ""
      },
      isSite: true,
      callMobile1: '',

      btn_no: true,
      bigS: {},
      numLimit: '0',
      able: true,
      isDirectExchangeDisabled: false,
      // 流程
      processId: '',
      showEdit: false,
      showAssignDialog: false,

      needSourceNo: true,
      writeSourceNo: false,
      disabledSourceNo: false,

      checkOrder: true,
      checkOrderBarcode: false,

      wfData: {
        wfEntityId: ''
      },



      optionsDisable: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },


      addButton: false,
      editButton: false,

      // 视频上传
      baseImgUrl: 'https:....',
      hideUpload: false,
      limitCount: 1,
      vedioUrl: '',
      dialogVisible: false,
      isShow: false,
      videoList: [],
      picUrl: '....',

      orderType: null,
      isExchange: 1,

      productOptions0: [],
      productOptions1: [],
      picList1: [],
      picList2: [],
      picList3: [],
      picList4: [],
      picList5: [],
      exchangeReasonList: [],
      exchangeTypeList: [],
      gasTypeList: [],
      dictTypesVipLevel: [],
      identifyResultList: [],
      qualityIdentifyList: [],
      responsibilityIdentifyList: [],
      dealWayList: [],
      warehouseList: [],

      url: 'https://t12.baidu.com/it/u=1689026450,3552214048&fm=58',
      srcList: [],
      showPreconditionDialog: false,
      showMulPreconditionDialog: false,

      warehouseType: 0,
      justShow: false,
      showPartsInvPop: false,
      showSitePop: false,
      showVideo: false,

      showAccidentPop: false,
      showQualityPop: false,
      showCustProfile: false,
      showWarehousePop: false,
      showAuditDialog: false,
      showCloseDialog: false,
      isCancel: false,
      orgOptions: {},
      orgValue: '',
      areaOption: [],
      areaValues: [],
      defaultReturnOption: [],
      defaultReturnValues: [],
      receiveAreaOption: [],
      receiveAreaValues: [],
      selectedData: [],
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      shippingMethodList: [],
      logisticsCompaniesList: [],

      showPhotoList: [],
      // 原始数据 因为页面上可以修改 导致传流程页面后会有问题
      fixData: {},
      formData: {
        isUserQuestion:null,
        exchangeNo: null, //退换单号;自动生成:TH+年月日时分秒+2位随机数
        stat: 1, //单据状态:1制单;2审核中;5已审核;6驳回;99取消
        billType: null, //单据类型:1退货;2退换货
        siteId: null, //服务商ID,关联sn_user.id;
        siteName: null, //服务商名称
        siteMan: null, //联系人
        siteManMobile: null, //联系人电话
        orgId: null, //部门ID，关联脚手架机构表sys_dept.dept_id
        orgName: null, //部门名称,冗余字段
        orgIdPath: null, //部门ID路径,冗余字段.重要
        isDirectExchange: 0, //是否直发机:0否1是
        sourceType: null, //退换来源:1安装工单;2维修工单;3委托维修;4事故报告;5质量报告;9其他
        sourceNo: null, //来源单据
        exchangeReason: null, //退换原因ID，关联脚手架数据字典项目表sys_dict_item.id
        exchangeReasonName: null, //退换原因名称,冗余字段
        exchangeType: null, //退换分类ID,关联脚手架数据字典项目表sys_dict_item.id
        exchangeTypeName: null, //退换分类名称,冗余字段
        problemRemark: null, //问题描述
        outWarehouseId: null, // 出库仓id
        inWarehouseId: null, // 入库仓id
        userName: null, //用户姓名
        userMobile: null, //用户电话
        userProvince: null, //省
        userCity: null, //市
        userCounty: null, //县
        userTown: null, //镇街
        areaId: null, //地区ID,关联bas_area.id
        userAddress: null, //详细地址
        itemId: null, //产品Id,关联bas_item.id
        itemCode: null, //产品编码,冗余字段
        itemName: null, //产品名称,冗余字段
        bigCategoryId: null, //产品大类ID,关联bas_item_category.id
        bigCategoryName: null, //产品大类名称。冗余字段
        smallCategoryId: null, //产品小类ID,关联bas_item_category.id
        smallCategoryName: null, //产品小类名称。冗余字段
        gasType: null, //气源ID，关联脚手架数据字典项目表sys_dict_item.id
        gasTypeName: null, //气源名称，冗余字段
        barcode: null, //产品条码
        buyAmount: null, // 购买金额
        buyDate: null, //购买日期
        returnLogisticsStat: 0, //退货状态:0未发货;2已发货;5已签收
        returnLogisticsCompany: null, //物流公司ID，关联脚手架数据字典项目表sys_dict_item.id
        returnLogisticsCompanyName: null, //物流公司名称,冗余字段
        returnLogisticsNo: null, //物流单号
        returnLogisticsSign: null, //退货签收时间
        backLogisticsStat: 0, //返还状态：0未发货;2已发货;5已签收
        backLogisticsCompany: null, //物流公司ID，关联脚手架数据字典项目表sys_dict_item.id
        backLogisticsCompanyName: null, //物流公司名称,冗余字段
        backLogisticsNo: null, //物流单号
        backLogisticsSign: null, //返还签收时间
        identifyResult: null, //鉴定结果ID，关联脚手架数据字典项目表sys_dict_item.id
        identifyResultName: null, //鉴定结果名称，冗余字段
        qualityIdentify: null, //质量鉴定ID，关联脚手架数据字典项目表sys_dict_item.id
        qualityIdentifyName: null, //质量鉴定名称，冗余字段
        responsibilityIdentify: null, //责任鉴定ID，关联脚手架数据字典项目表sys_dict_item.id
        responsibilityIdentifyName: null, //责任鉴定名称，冗余字段
        canFix: null, //是否可维修:0否1是
        systemSuggestDeal: null, //系统建议方案
        dealWay: null, //处理方案ID,关联脚手架数据字典项目表sys_dict_item.id
        dealWayName: null, //处理方案名称,冗余字段
        qrCode: null,

        receiveMan: null,
        receiveMobile: null,
        receiveProvince: null,
        receiveCity: null,
        receiveCounty: null,
        receiveTown: null,
        receiveAreaId: null,
        receiveAddress: null,

        backAmount: 0,
        differenceAmount: 0,

        sysmtomPic: null, //故障点图片
        installPic: null, //安装环境图片
        labelPic: null, //铭牌信息图片
        barcodePic: null, //产品条码图片
        vedioUrl: null, //视频
        profileId: null,//用户档案Id,关联bas_cust_profile.id
        vipLevel: null,

        send1Flag: null, // 销售传单状态：0未传;1失败;2已传
        send1No: '', // 销售对接单号
        send1Message: '', // 销售传单备注
        erpCustCode: '', // erp客户编码
        send2Flag: null, // 交货传单状态：0未传;1失败;2已传
        send2No: '', // 交货对接单号
        send2Message: '', // 交货传单备注
        send3Flag: null, // 出库传单状态：0未传;1失败;2已传
        send3No: '', // 出库对接单号
        send3Message: '', // 出库传单备注
        send4Flag: null, // 通知入库传单状态：0未传;1失败;2已传
        send4No: '', // 通知入库对接单号
        send4Message: '', // 通知入库传单备注
        send5Flag: null, // 退货传单状态：0未传;1失败;2已传
        send5No: '', // 退货对接单号
        send5Message: '', // 退货传单备注
        send6Flag: null, // 退货传单状态：0未传;1失败;2已传
        send6No: '', // 退货对接单号
        send6Message: '', // 退货传单备注
        send7Flag: null, // 退货传单状态：0未传;1失败;2已传
        send7No: '', // 退货对接单号
        send7Message: '', // 退货传单备注
        send8Flag: null, // 退货传单状态：0未传;1失败;2已传
        send8No: '', // 退货对接单号
        send8Message: '', // 退货传单备注

        send9Flag: null, // 退货传单状态：0未传;1失败;2已传
        send9No: '', // 退货对接单号
        send9Message: '', // 退货传单备注

        send10Flag: null, // 退货传单状态：0未传;1失败;2已传
        send10No: '', // 退货对接单号
        send10Message: '', // 退货传单备注

        defaultReturnProvince: null,
        defaultReturnCity: null,
        defaultReturnCounty: null,
        defaultReturnTown: null,
        defaultReturnAddress: '',
        defaultReturnAreaId: '',

        returnFactoryType:'',

        backList: []
      },

      show3: false,
      node: true,
      ////////////////////////////////////////////////////////////////////////////////////////////
      isEdit: false,
      tabIndex: 'first',
      dataId: '',

    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }

  },
  created() {
    if (this._dataId && !isNaN(this._dataId)){
      this.dataId = this._dataId;
    }else{
      this.showButton = true;
    }
    this.endButton = this.permissions["wkExchangeOrderEnd"];
    //提交
    this.submitButton = this.permissions["wkExchangeOrderSubmit"];
    //取消
    this.cancleButton = this.permissions["wkExchangeOrderCancle"];
    //一键生成安装单
    this.addInstallOrderButton = this.permissions["wkExchangeOrderAddInstallOrder"];
    //一键生成拆机单
    this.addDismantleOrderButton = this.permissions["wkExchangeOrderAddDismantleOrder"];
    //可换机型
    this.canChangeModelButton = this.permissions["wkExchangeOrderCanChangeModel"];
    //可换机型驳回
    this.canChangeModelRejectButton = this.permissions["wkExchangeOrderCanChangeModelReject"];
    //创建销售发货订单
    this.createSaleDeliveryOrderButton = this.permissions["wkExchangeOrderCreateSaleDeliveryOrder"];
    //创建销售发货订单驳回
    this.createSaleDeliveryOrderRejectButton = this.permissions["wkExchangeOrderCreateSaleDeliveryOrderReject"];
    //总部服务支持经理审批
    this.headOfficeServiceSupportManagerApprovalButton = this.permissions["wkExchangeOrderHeadOfficeServiceSupportManagerApprovalButton"];
    //新件收货
    this.newItemReceiptButton = this.permissions["wkExchangeOrderNewItemReceipt"];
    //旧件返厂
    this.oldItemReturnFactoryButton = this.permissions["wkExchangeOrderOldItemReturnFactoryButton"];
    //旧机回收
    this.oldItemRecoveryButton = this.permissions["wkExchangeOrderOldItemRecoveryButton"];
    //总部旧件签收
    this.headOfficeOldItemSignButton = this.permissions["wkExchangeOrderHeadOfficeOldItemSignButton"];
    //总部旧件退回
    this.headOfficeOldItemReturnButton = this.permissions["wkExchangeOrderHeadOfficeOldItemReturnButton"];
    //服务商旧机签收
    this.serviceProviderOldItemSignButton = this.permissions["wkExchangeOrderServiceProviderOldItemSignButton"];
    //品质鉴定
    this.qualityIdentificationButton = this.permissions["wkExchangeOrderQualityIdentificationButton"];
    //确认折算方式
    this.confirmExchangeWayButton = this.permissions["wkExchangeOrderConfirmExchangeWayButton"];
    //总部输出折算方案
    this.headOfficeOutputExchangeSchemeButton = this.permissions["wkExchangeOrderHeadOfficeOutputExchangeScheme"];
    //确认折算方案
    this.confirmExchangeSchemeButton = this.permissions["wkExchangeOrderConfirmExchangeSchemeButton"];
    //是否挽留
    this.isRetainButton = this.permissions["wkExchangeOrderIsRetainButton"];
    //结束
    this.endButton = this.permissions["wkExchangeOrderEndButton"];

    const userInfo = store.getters.userInfo;

    // if (userInfo.snUserId) {
    if (this.currentSiteData) {
      this.isSite = true;
      console.log("this.isSite = true;")
    } else {
      this.isSite = false;
    }
  },
  mounted() {
    this.loadOrgData()
    this.loadDictData()
    this.loadWarehouse()
    this.loadProductOption0()
    this.getData()
  },
  watch: {
    // 联系方式验证

    'formData.outType': {
      handler(n) {
        if (n == 1) {  // 总部
          this.warehouseType = 0
        } else if (n == 2) {   // 中心
          this.warehouseType = 1
        }
      },
      deep: true
    },
    'formData.spPartsApplyLineDTOList': {
      handler(n) {
        if (n) {
          let temp = 0
          let temp1 = 0
          n.forEach(item => {
            temp += Number(item.applyQty)
            temp1 += Number(item.applyQty) * Number(item.sitePrice)
          })
          this.formData.applyQtyAll = temp
          this.formData.applyAmountAll = temp1
        }
      },
      deep: true
    }
  },
  methods: {
    uploadVideo(){
      if(this.formData.stat == 1 || this.isAdd){
        this.showVideo = true
      }
    },
    // 物流弹窗
    showDeliverNo(deliverNo,deliverCompanyName,deliverMobile) {
      this.$mask.open()
      this.$http.post(api.wkExchangeOrder.getLogisticsInformationUrl,
        {deliverNo:deliverNo, deliverCompanyName:deliverCompanyName,deliverMobile:deliverMobile}
      ).then(res => {
        this.logisticsInformationInfo = res.data.data
        this.showLogisticsInformationInfoDialog = true
        this.$mask.close()
      }).catch(() => {
        this.$mask.close()
      })
    },


    closeDraw(type){
      if (type){
        this.showCommentDraw = false
        this.reload()
      }else{
        this.showCommentDraw = false
      }
    },
    closeDialog(type){
      if (type){
        this.showOldItemRecoveryDialog = false
        this.showOldItemReturnDialog = false
        this.showZbOldItemReturnDialog = false
        this.showQuantityCheckDialog = false
        this.showSchemeEntryDialog = false
        this.showIsWl = false
        this.getData()
      }else{
        this.showOldItemRecoveryDialog = false
        this.showOldItemReturnDialog = false
        this.showZbOldItemReturnDialog = false
        this.showQuantityCheckDialog = false
        this.showSchemeEntryDialog = false
        this.showIsWl = false
      }
    },
    chooseItems(type){
      if (type){
        this.showChooseItemDialog = false
        this.getData()
      }else{
        this.showChooseItemDialog = false
      }
    },
    exchangeBillCommit(row){
      console.log("row-----------",row)
      this.formData.siteId = row.siteId
      this.formData.siteName = row.siteName
      this.formData.billId = row.billId
      this.formData.billNo = row.billNo
      this.formData.siteMan = row.siteMan
      this.formData.siteManMobile = row.siteManMobile
      this.orgValue = row.orgId
      this.formData.orgId = row.orgId
      this.formData.orgName = row.orgName
      this.formData.orgIdPath = row.orgIdPath
      this.formData.isDirectExchange = row.isDirectExchange
      this.formData.exchangeReason = row.exchangeReason
      this.formData.exchangeReasonName = row.exchangeReasonName
      this.formData.exchangeType = row.exchangeType
      this.formData.exchangeTypeName = row.exchangeTypeName
      this.formData.problemRemark = row.problemRemark
      this.formData.userName = row.userName
      this.formData.userMobile = row.userMobile
      this.callMobile1 = row.siteManMobile
      this.formData.areaId = row.areaId
      this.formData.userProvince = row.userProvince
      this.formData.userCity = row.userCity
      this.formData.userCounty = row.userCounty
      this.formData.userTown = row.userTown
      this.formData.userAddress = row.userAddress
      this.formData.itemId = row.itemId
      this.formData.itemName = row.itemName
      this.formData.itemCode = row.itemCode
      this.formData.barcode = row.barcode
      this.formData.bigCategoryId = row.bigCategoryId
      this.formData.bigCategoryName = row.bigCategoryName
      if (row.smallCategoryId && row.smallCategoryId>0){
        this.formData.smallCategoryId = row.smallCategoryId
        this.formData.smallCategoryName = row.smallCategoryName
      }
      this.formData.buyDate = row.buyDate
      this.formData.buyAmount = row.buyAmount
      this.formData.gasType = row.gasType
      this.formData.gasTypeName = row.gasTypeName
      this.formData.isUserQuestion = row.isUserQuestion
      this.formData.outWarehouseId = row.outWarehouseId
      this.formData.inWarehouseId = row.inWarehouseId
      this.formData.problemRemark  = row.problemRemark
      this.formData.defaultReturnAreaId = row.defaultReturnAreaId
      this.formData.defaultReturnAddress = row.defaultReturnAddress
      // if (this.formData.defaultReturnAreaId){
      //   this.$http({
      //     url: api.basArea.echoAddressUrl,
      //     method: 'post',
      //     data: { id: this.formData.defaultReturnAreaId }
      //   }).then(res => {
      //     console.log(res)
      //     this.defaultReturnOption = res.data.data.options
      //     this.defaultReturnValues = res.data.data.values
      //     this.defaultReturnArea = res.data.data.names
      //   })
      // }
      this.formData.receiveMan  = row.receiveMan
      this.formData.receiveMobile  = row.receiveMobile
      this.formData.receiveProvince  = row.receiveProvince
      this.formData.receiveCity  = row.receiveCity
      this.formData.receiveCounty  = row.receiveCounty
      this.formData.receiveTown  = row.receiveTown
      this.formData.receiveAreaId  = row.receiveAreaId
      this.formData.receiveAddress  = row.receiveAddress
      this.formData.sysmtomPic = row.sysmtomPic
      this.formData.installPic = row.installPic
      this.formData.labelPic = row.labelPic
      this.formData.barcodePic = row.barcodePic
      this.formData.vedioUrl = row.vedioUrl
      this.echoAddress()
      this.loadProductOption1()

    },
    closeD33() {
      this.showPreview = false

    },
    // 文件预览
    openVideo(value) {
      this.imgVisbleURL = value
      this.showPreview = true
    },

    // 视频下载
    handleDownload(Vname,Vurl) {
      console.log(Vname,Vurl, "视频下载");
      // let url=file.type
      let url = Vurl
      let name = Vname

      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()


      // window.open(url,'_blank');
    },
    reloadWf() {
      console.log('保存前的刷新');
      this.$emit('editViewDataUpdate')
    },
    commitSelectedRow1(data) {
      console.log(data, '网点选中')
      let temp = this.siteName
      if (temp.length === 0) {
        this.siteName = data
      } else {
        data.forEach(item => {
          temp.push(item)
        })
      }
    },
    ableShowMulPreconditionDialog() {
      if (this.able) {
        return this.$message.warning('无法操作')
      } else {
        this.showMulPreconditionDialog = true
      }
    },
    // 加载产品大类
    loadProductOption0() {
      fetchTree({
        categoryType: 1,  // 产品
        // usable: 1  // 加载启用的
      }).then(response => {
        this.productOptions0 = []
        response.data.data.forEach(item => {
          this.productOptions0.push({
            label: item.categoryName,
            value: item.id
          })
        })
      });
    },
    // 加载产品小类
    loadProductOption1() {
      if (this.formData.bigCategoryId === ''
        || this.formData.bigCategoryId === null
        || this.formData.bigCategoryId === undefined) {
        this.productOptions1 = []
      } else {
        fetchTree({
          categoryType: 1,  // 产品
          // usable: 1,  // 加载启用的
          parentId: this.formData.bigCategoryId
        }).then(response => {
          this.productOptions1 = []
          response.data.data.forEach(item => {
            this.productOptions1.push({
              label: item.categoryName,
              value: item.id
            })
          })
        })
      }
    },
    // 产品大类选中加载小类
    productSelectOne() {
      this.productOptions1 = []
      this.formData.smallCategoryId = null
      this.loadProductOption1()
    },
    commitSelectedRow(data) {

      console.log(data, 'data传过来的值  编码');
      this.formData.itemId = data.id
      this.formData.itemCode = data.itemCode
      this.formData.itemName = data.itemName
      this.formData.bigCategoryId = data.bigCategoryId
      this.formData.bigCategoryName = data.bigCategoryName
      this.formData.smallCategoryId = data.smallCategoryId
      this.formData.smallCategoryName = data.smallCategoryName
    },
    commitMulSelectedRow(data) {

      console.log(data, 'data传过来的值  编码');
      this.formData.backList.push({
        selectId: -new Date().getTime() + Math.floor(Math.random() * 100),
        itemId: data.id,
        itemCode: data.itemCode,
        itemName: data.itemName,
        bigCategoryId: data.bigCategoryId,
        bigCategoryName: data.bigCategoryName,
        smallCategoryId: data.smallCategoryId,
        smallCategoryName: data.smallCategoryName,
        qty: 1,
      })
    },
    deleteItemData() {
      if (this.able) {
        return this.$message.warning('无法操作')
      }
      let selectedData = this.selectedData
      if (selectedData == null || selectedData.length == 0) {
        this.$message.warning('请先选中数据')
      } else {
        let backList = this.formData.backList;
        selectedData.forEach(item => {
          backList = backList.filter(item1 => item1.selectId != item.selectId)
        })
        this.formData.backList = backList
      }
    },
    exchangeTypeChange() {
      this.isDirectExchangeDisabled = false
      if (this.formData.exchangeType) {
        this.exchangeTypeList.forEach(item => {
          if (this.formData.exchangeType === item.value && item.label == '委托维修') {
            this.formData.isDirectExchange = 0
            this.isDirectExchangeDisabled = true
          }
        })
      }
    },
    sourceTypeChange() {
      this.formData.sourceNo = ""
      this.checkOrder = true
      this.sourceTypeShow()
    },
    sourceTypeShow() {
      if (this.formData.sourceType == 3) {
        this.needSourceNo = false;
        this.writeSourceNo = true;
        this.disabledSourceNo = false;
      } else if (this.formData.sourceType == 9) {
        this.needSourceNo = false;
        this.writeSourceNo = false;
        this.disabledSourceNo = true;
      } else {
        this.needSourceNo = true;
        this.writeSourceNo = false;
        this.disabledSourceNo = false;
      }
    },

    searchOrder() {
      // let errorMsg = '';
      // if (!this.formData.siteId) {
      //   errorMsg += '网点 '
      // }
      //
      // if (errorMsg) {
      //   this.$message.error("请选择" + errorMsg);
      //   return false;
      // }

      this.showExchangeBillDialog = true
    },



    // 返回列表页
    goBackIndex() {
      this.$emit('goBackIndex')
    },

    // 添加明细
    confirm(data) {
      console.log(data, '明细')
      let temp = this.formData.spPartsApplyLineDTOList
      if (temp == null) {
        temp = []
      }
      data.forEach(item => {
        temp.push({
          partsId: item.partsId,
          partsCode: item.partsCode,
          partsName: item.partsName,
          sitePrice: item.price,
          applyQty: 1,
          applyAmount: item.price,
          checkQty: 0,
          checkAmount: 0,
          outQty: 0,
          outAmount: 0,
          getQty: 0,
          getAmount: 0,
          diffQty: 0,
          diffAmount: 0,
          getStat: 0,
          selectId: item.id
        })
      })
      this.formData.spPartsApplyLineDTOList = temp
    },

    // 抽屉关闭
    closeD() {
      this.showAuditDialog = false
      this.showCloseDialog = false
    },


    deleteData() {
      let temp = this.formData.spPartsApplyLineDTOList
      this.selectedData.forEach(item => {
        temp = temp.filter(item1 => item1.selectId != item.selectId)
      })
      this.formData.spPartsApplyLineDTOList = temp
    },
    selectChangeEvent(data) {
      console.log('选中数据', data)
      this.selectedData = data.records
    },


    // 加载数据字典中物流公司，运输方式

    loadWarehouse() {
      this.$http.get(api.wkExchangeBill.addDataUrl + 'getOutWarehouse', {
      }).then(res => {
        this.warehouseList = res.data.data
      })
    },

    loadDictData() {
      // 物流公司
      loadDictData(dictType.logisticsCompanies).then(res => {
        this.logisticsCompaniesList = []
        res.data.data.forEach(item => {
          this.logisticsCompaniesList.push({
            label: item.label,
            value: item.id
          })
        })
      })

      // vip级别
      loadDictData('VIP级别').then(res => {
        this.dictTypesVipLevel = res.data.data
      })

      // 运输方式
      loadDictData(dictType.shippingMethod).then(res => {
        this.shippingMethodList = []
        res.data.data.forEach(item => {
          this.shippingMethodList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      loadDictData("退换原因").then(res => {
        this.exchangeReasonList = []
        res.data.data.forEach(item => {
          this.exchangeReasonList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      loadDictData("退换分类").then(res => {
        this.exchangeTypeList = []
        res.data.data.forEach(item => {
          this.exchangeTypeList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      loadDictData("气源名称").then(res => {
        this.gasTypeList = []
        res.data.data.forEach(item => {
          this.gasTypeList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      loadDictData("鉴定结果").then(res => {
        this.identifyResultList = []
        res.data.data.forEach(item => {
          this.identifyResultList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      loadDictData("质量鉴定").then(res => {
        this.qualityIdentifyList = []
        res.data.data.forEach(item => {
          this.qualityIdentifyList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      loadDictData("责任鉴定").then(res => {
        this.responsibilityIdentifyList = []
        res.data.data.forEach(item => {
          this.responsibilityIdentifyList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      loadDictData("处理方案名称").then(res => {
        this.dealWayList = []
        res.data.data.forEach(item => {
          this.dealWayList.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },

    getItemPrice(itemId) {
      this.$http({
        url: api.basItemPrice.getItemPriceByItemId + "/" + itemId,
        method: 'get',
        data: {}
      }).then(res => {
        console.log(res.data.data)
        if (res.data.data) {
          this.formData.buyAmount = res.data.data.price
        }
      })
    },


    // 仓库弹框选中
    warehouseCommit(data) {
      console.log('选中的仓库', data)
      this.formData.outWarehouseId = data.warehouseId
      this.formData.outWarehouseName = data.warehouseName
    },



    getCustmerInfo() {
      // 如果存在用户档案 需要查询下用户档案vip等级 避免在工单查询中带
      this.$http({
        url: api.basCustProfile.getDataUrl,
        method: 'post',
        data: {
          id: this.formData.profileId
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        console.log('res', response.data.data)
        let data = response.data.data

        this.formData.vipLevel = data.vipLevel
      })
    },

    // 用户档案弹框选中
    custProfileCommit(data) {
      console.log('选中的用户', data)
      this.formData.profileId = data.id
      this.formData.profileNo = data.profileNo
      this.formData.userType = data.userType
      this.formData.userMobile = data.callMobile
      this.formData.userName = data.custName
      this.formData.vipLevel = data.vipLevel
    },

    // 网点弹框选中
    siteCommit(data) {
      console.log('选中的数据', data)
      console.log('选中的网点', data.id)
      console.log('选中的网点', this.formData.siteId)
      if (this.formData.siteId !== data.id) {
        this.formData.sourceNo = '';
      }
      this.formData.siteId = data.id
      this.formData.siteName = data.name
      this.orgValue = data.orgId
      this.formData.orgId = data.orgId
      this.formData.orgName = data.orgName
      this.formData.orgIdPath = data.orgIdPath


      console.log('修改后的数据', this.formData)
    },
    // 视频上传文件
    commitVideo(data) {
      console.log('选中的视频数据', data)
      this.formData.vedioName=data.vedioName
      this.formData.vedioUrl=data.vedioUrl





      // console.log('修改后的数据', this.formData)
    },

    // 加载机构数据
    loadOrgData() {
      fetchTree2(this.queryParams).then(response => {
        this.orgOptions = response.data.data
        // this.orgOptions =res.data.data
        console.log(this.orgOptions, "this.orgOptions的值");

      });

    },


    // 机构选中
    orgHandleChange(data) {
      if (data.length !== 0) {
        this.$http({
          url: '/admin/dept/' + data[data.length - 1],
          method: 'get'
        }).then(res => {
          console.log('选中机构', res.data.data)
          this.formData.orgId = res.data.data.deptId
          this.formData.orgName = res.data.data.name
          this.formData.orgIdPath = res.data.data.orgIdPath
        })
      }
    },
    clearSite() {
      this.formData.siteId = '';
    },
    clearSourceType() {
      this.formData.sourceNo = '';
    },

    // 地址选中事件
    handleChange() {
      const areaNode = this.$refs["cascader"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        if (areaNode[0].level == 1) {
          this.formData.country = areaNode[0].label;
          this.formData.userProvince = null;
          this.formData.userCity = null;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 2) {
          this.formData.userProvince = areaNode[0].label;
          this.formData.userCity = null;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 3) {
          this.formData.userCity = areaNode[0].label;
          this.formData.userCounty = null;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 4) {
          this.formData.userCounty = areaNode[0].label;
          this.formData.userTown = null;
        } else if (areaNode[0].level == 5) {
          this.formData.userTown = areaNode[0].label;
        }
        this.formData.areaId = areaNode[0].value
      } else {
        this.formData.areaId = null;
        this.formData.country = null;
        this.formData.userProvince = null;
        this.formData.userCity = null;
        this.formData.userCounty = null;
        this.formData.userTown = null;
      }

      const panelRefs = this.$refs.cascader.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },

    // 地址选中事件
    handleChange2() {
      const areaNode = this.$refs["cascader2"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        if (areaNode[0].level == 1) {
          this.formData.receiveCountry = areaNode[0].label;
          this.formData.receiveProvince = null;
          this.formData.receiveCity = null;
          this.formData.receiveCounty = null;
          this.formData.receiveTown = null;
        } else if (areaNode[0].level == 2) {
          this.formData.receiveProvince = areaNode[0].label;
          this.formData.receiveCity = null;
          this.formData.receiveCounty = null;
          this.formData.receiveTown = null;
        } else if (areaNode[0].level == 3) {
          this.formData.receiveCity = areaNode[0].label;
          this.formData.receiveCounty = null;
          this.formData.receiveTown = null;
        } else if (areaNode[0].level == 4) {
          this.formData.receiveCounty = areaNode[0].label;
          this.formData.receiveTown = null;
        } else if (areaNode[0].level == 5) {
          this.formData.receiveTown = areaNode[0].label;
        }
        this.formData.receiveAreaId = areaNode[0].value
      } else {
        this.formData.receiveAreaId = null;
        this.formData.receiveCountry = null;
        this.formData.receiveProvince = null;
        this.formData.receiveCity = null;
        this.formData.receiveCounty = null;
        this.formData.receiveTown = null;
      }

      const panelRefs = this.$refs.cascader2.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },
    // 地址选中事件
    handleChange3() {
      const areaNode = this.$refs["cascader3"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        if (areaNode[0].level == 1) {
          this.formData.defaultReturnCountry = areaNode[0].label;
          this.formData.defaultReturnProvince = null;
          this.formData.defaultReturnCity = null;
          this.formData.defaultReturnCounty = null;
          this.formData.defaultReturnTown = null;
        } else if (areaNode[0].level == 2) {
          this.formData.defaultReturnProvince = areaNode[0].label;
          this.formData.defaultReturnCity = null;
          this.formData.defaultReturnCounty = null;
          this.formData.defaultReturnTown = null;
        } else if (areaNode[0].level == 3) {
          this.formData.defaultReturnCity = areaNode[0].label;
          this.formData.defaultReturnCounty = null;
          this.formData.defaultReturnTown = null;
        } else if (areaNode[0].level == 4) {
          this.formData.defaultReturnCounty = areaNode[0].label;
          this.formData.defaultReturnTown = null;
        } else if (areaNode[0].level == 5) {
          this.formData.defaultReturnTown = areaNode[0].label;
        }
        this.formData.defaultReturnAreaId = areaNode[0].value
      } else {
        this.formData.defaultReturnAreaId = null;
      }

      const panelRefs = this.$refs.cascader3.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },


    // 地址懒加载
    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          console.log('childNodes', childNodes)
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          console.log(node.children, 'child')
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },

    // 地址数据回显
    echoAddress() {
      if (this.formData.areaId !== null && this.formData.areaId !== '' && this.formData.areaId != 0) {
        // this.cascaderShow = false
        this.$http({
          url: api.basArea.echoAddressUrl,
          method: 'post',
          data: { id: this.formData.areaId }
        }).then(res => {
          console.log(res)
          this.areaOption = res.data.data.options
          this.areaValues = res.data.data.values
          this.area = res.data.data.names
        })
      }
      if (!!(this.formData.receiveAreaId)) {
        // this.cascaderShow = false
        this.$http({
          url: api.basArea.echoAddressUrl,
          method: 'post',
          data: { id: this.formData.receiveAreaId }
        }).then(res => {
          console.log(res)
          this.receiveAreaOption = res.data.data.options
          this.receiveAreaValues = res.data.data.values
          this.receiveArea = res.data.data.names
        })
      }
      if (!!(this.formData.defaultReturnAreaId)) {
        // this.cascaderShow = false
        this.$http({
          url: api.basArea.echoAddressUrl,
          method: 'post',
          data: { id: this.formData.defaultReturnAreaId }
        }).then(res => {
          console.log(res)
          this.defaultReturnOption = res.data.data.options
          this.defaultReturnValues = res.data.data.values
          this.defaultReturnArea = res.data.data.names
        })
      }
    },
    handleCommand(command) {
      let row = this.formData
      this.exchangeOrderId = row.id
      this.exchangeOrderNo = row.exchangeOrderNo
      this.currentRow = row
      this.rejectType = null
      if (command === '提交') { //提交
        if (!this.formData.returnFactoryType){
          this.$message.warning('请选择返厂方式')
          return
        }
        this.$baseConfirm('您确定要提交吗？').then(() => {

          if (row.id == null) {
            if (!this.formData.isDirectExchange == null){
              this.$message.warning('请选择是否直发机')
              return
            }
            if (!this.formData.isUserQuestion == null){
              this.$message.warning('请选择是否用户问题')
              return
            }
            if (!this.formData.defaultReturnAreaId){
              this.$message.warning('请选择总部收货异常默认退回地区')
              return
            }
            if (!this.formData.defaultReturnAddress){
              this.$message.warning('请选择总部收货异常默认退回详细地址')
              return
            }

            if (!this.formData.receiveMan){
              this.$message.warning('请输入收货人姓名')
              return
            }
            if (!this.formData.receiveMobile){
              this.$message.warning('请输入收货人手机号')
              return
            }

            if (!this.formData.receiveAreaId){
              this.$message.warning('请选择收货人地址')
              return
            }

            if (!this.formData.receiveAddress){
              this.$message.warning('请输入收货人详细地址')
              return
            }

            if (!this.formData.sysmtomPic){
              this.$message.warning('请上传故障点图片')
              return
            }
            if (!this.formData.installPic){
              this.$message.warning('请上传安装环境图片')
              return
            }
            if (!this.formData.labelPic){
              this.$message.warning('请上传铭牌信息图片')
              return
            }
            if (!this.formData.barcodePic){
              this.$message.warning('请上传产品条码图片')
              return
            }

            if (!this.formData.vedioUrl){
              this.$message.warning('请上传视频')
              return
            }

            this.formData.siteManMobile = this.callMobile1
          }
          this.$mask.open()
          this.$http({
            url: api.wkExchangeOrder.commitDataUrl,
            method: 'post',
            data: this.formData,
            isLoading: true,
          }).then(response => {
            this.$mask.close()
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            this.getData()
          }).catch(() => {
            this.$message.error("保存失败！");
            this.$mask.close()
          });

        })
      } else if (command === '取消') { //取消
        this.$baseConfirm('您确定要取消吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: api.wkExchangeOrder.cancelDataUrl,
            method: 'post',
            data: {id:row.id},
            isLoading: true,
          }).then(response => {
            this.$mask.close()
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            this.getData()
          }).catch(() => {
            this.$message.error("操作失败！");
            this.$mask.close()
          });

        })
      } else if (command === '一键生成安装单') {
        var params = {}
        this.$router.push({
          path: '/workorder/orderaccess/access/index',query: { exchangeOrderId: row.id,serviceTypeName:'安装工单' }
        })
      } else if (command === '一键生成拆机单') {
        var params = {}
        this.$router.push({
          path: '/workorder/orderaccess/access/index',query: { exchangeOrderId: row.id,serviceTypeName:'退换货拆机' }
        })
      }else if(command === '可换机型'){
        this.chooseItemParams = {id:row.id,buyAmount:row.buyAmount}
        this.showChooseItemDialog = true
      }else if(command === '可换机型驳回'){
        //打开驳回页面
        this.rejectType = 1
        this.commentDrawTitle = '可换机型驳回'
        this.showCommentDraw = true
      }else if(command === '创建销售发货订单驳回'){
        //打开驳回页面
        this.rejectType = 2
        this.commentDrawTitle = '创建销售发货订单驳回'
        this.showCommentDraw = true
      }else if(command === '创建销售发货订单'){
        this.$baseConfirm('您确定要创建销售发货订单吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: api.wkExchangeOrder.commitCreateSaleOrderDataUrl,
            method: 'post',
            data: {id:row.id},
            isLoading: true,
          }).then(response => {
            this.$mask.close()
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            this.getData()
          }).catch(() => {
            this.$message.error("操作失败！");
            this.$mask.close()
          });

        })
      }else if(command ==='总部服务支持经理审批'){
        this.commentDrawTitle = '总部服务支持经理审批'
        this.showCommentDraw = true
      }else if(command ==='新件收货'){
        this.$baseConfirm('您确定要新件收货确认吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: api.wkExchangeOrder.newItemTakeUrl,
            method: 'post',
            data: {id:row.id},
            isLoading: true,
          }).then(response => {
            this.$mask.close()
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            this.getData()
          }).catch(() => {
            this.$message.error("操作失败！");
            this.$mask.close()
          });

        })
      }else if(command ==='旧件返厂'){
        this.showOldItemReturnDialog = true
        this.exchangeOrderObj ={siteId:row.siteId,installOrderId:row.installOrderId}

      }else if(command ==='旧机回收'){
        this.showOldItemRecoveryDialog = true
      }else if(command ==='总部旧件签收'){
        this.$baseConfirm('您确定要旧件签收确认吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: api.wkExchangeOrder.zbOldItemTakeUrl,
            method: 'post',
            data: {id:row.id},
            isLoading: true,
          }).then(response => {
            this.$mask.close()
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            this.getData()
          }).catch(() => {
            this.$message.error("操作失败！");
            this.$mask.close()
          });

        })
      }else if (command ==='总部旧件退回'){
        this.showZbOldItemReturnDialog = true
      }else if (command === '服务商旧机签收') {
        this.$baseConfirm('您确定要旧件签收确认吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: api.wkExchangeOrder.oldItemTakeUrl,
            method: 'post',
            data: {id: row.id},
            isLoading: true,
          }).then(response => {
            this.$mask.close()
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            this.getData()
          }).catch(() => {
            this.$message.error("操作失败！");
            this.$mask.close()
          });
        })
      }else if (command === '品质鉴定'){
        this.showQuantityCheckDialog = true
      }else if(command === '确认结算方式'){
        this.commentDrawTitle = '确认结算方式'
        this.showCommentDraw = true
      }else if (command === '总部输出折算方案'){
        this.showSchemeEntryDialog = true
      }else if (command ==='确认折算方案'){
        this.$baseConfirm('您确定要确认折算方案吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: api.wkExchangeOrder.sureSettleSchemeUrl,
            method: 'post',
            data: {id: row.id},
            isLoading: true,
          }).then(response => {
            this.$mask.close()
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            this.getData()
          }).catch(() => {
            this.$message.error("操作失败！");
            this.$mask.close()
          });
        })
      }else if(command ==='是否挽留'){
        this.showIsWl = true
      }else if(command ==='结束'){
        this.$baseConfirm('您确定要结束吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: api.wkExchangeOrder.doEndUrl,
            method: 'post',
            data: {id: row.id},
            isLoading: true,
          }).then(response => {
            this.$mask.close()
            if (response.data.code == 0) {
              this.$message({
                type: response.data.type,
                message: response.data.data
              });
            } else {
              this.$message({
                type: response.data.type,
                message: response.data.content
              });
            }
            this.getData()
          }).catch(() => {
            this.$message.error("操作失败！");
            this.$mask.close()
          });
        })
      }
    },

    saveData(formName) {
      if (!this.formData.returnFactoryType){
        this.$message.warning('请选择返厂方式')
        return
      }
      if (!this.formData.isDirectExchange == null){
        this.$message.warning('请选择是否直发机')
        return
      }
      if (!this.formData.isUserQuestion == null){
        this.$message.warning('请选择是否用户问题')
        return
      }
      if (!this.formData.defaultReturnAreaId){
        this.$message.warning('请选择总部收货异常默认退回地区')
        return
      }
      if (!this.formData.defaultReturnAddress){
        this.$message.warning('请选择总部收货异常默认退回详细地址')
        return
      }

      if (!this.formData.receiveMan){
        this.$message.warning('请输入收货人姓名')
        return
      }
      if (!this.formData.receiveMobile){
        this.$message.warning('请输入收货人手机号')
        return
      }

      if (!this.formData.receiveAreaId){
        this.$message.warning('请选择收货人地址')
        return
      }

      if (!this.formData.receiveAddress){
        this.$message.warning('请输入收货人详细地址')
        return
      }

      if (!this.formData.sysmtomPic){
        this.$message.warning('请上传故障点图片')
        return
      }
      if (!this.formData.installPic){
        this.$message.warning('请上传安装环境图片')
        return
      }
      if (!this.formData.labelPic){
        this.$message.warning('请上传铭牌信息图片')
        return
      }
      if (!this.formData.barcodePic){
        this.$message.warning('请上传产品条码图片')
        return
      }

      if (!this.formData.vedioUrl){
        this.$message.warning('请上传视频')
        return
      }


      // if (this.formData.exchangeReason) {
      //   this.exchangeReasonList.forEach(item => {
      //     if (this.formData.exchangeReason === item.value) {
      //       this.formData.exchangeReasonName = item.label
      //     }
      //   })
      // }
      // if (this.formData.exchangeType) {
      //   this.exchangeTypeList.forEach(item => {
      //     if (this.formData.exchangeType === item.value) {
      //       this.formData.exchangeTypeName = item.label
      //     }
      //   })
      // }
      this.formData.siteManMobile = this.callMobile1

        this.$baseConfirm('您确定要保存吗？').then(() => {
          this.$mask.open()

          console.log(this.formData.vedioUrl, 'this.formData.vedioUrl的值');
          var url = (this.isEdit ? api.wkExchangeOrder.updateDataUrl : api.wkExchangeOrder.addDataUrl);
          var method = (this.isEdit ? 'post' : 'post');
          this.$http({
            url: url,
            method: method,
            data: this.formData,
            isLoading: true,
          }).then(response => {
            this.$message.success("保存成功！");
            this.getData()
            this.$mask.close()

            // this.$emit('editViewDataUpdate')
            // this.$baseReload()
          }).catch(() => {
            this.$message.error("保存失败！");
            this.$mask.close()
          });
        })

    },

    getData() {
      // console.log('getData')
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.wkExchangeOrder.getDataUrl ,
          method: 'post',
          isLoading: true,
          data:{id:this.dataId},
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data
          this.formData = data
          this.callMobile1 = this.formData.siteManMobile

          console.log(this.formData, "this.formData 的值");
          this.justShow = this.formData.stat != 1 && this.formData.stat != 6
          this.orgValue = data.orgId
          this.echoAddress()
          let big = {}
          big.bigCategoryId = this.formData.bigCategoryId,
          big.bigCategoryName = this.formData.bigCategoryName,
          big.smallCategoryId = this.formData.smallCategoryId,
          big.smallCategoryName = this.formData.smallCategoryName,
          this.bigS = big
          console.log(this.bigS, "this.big6666666的值");

          this.loadProductOption1()
          this.showButton = true
        })
      } else {
        this.enabled = true;
        if (this.currentSiteData !== null) { //网点端
          console.log("this.currentSiteData", this.currentSiteData)
          this.formData.siteName = this.currentSiteData.userName
          this.formData.siteId = this.currentSiteData.id
          this.orgValue = this.currentSiteData.snSiteInfoDTO.orgId
          this.formData.orgId = this.currentSiteData.snSiteInfoDTO.orgId
          this.formData.orgName = this.currentSiteData.snSiteInfoDTO.orgName
          this.formData.orgIdPath = this.currentSiteData.snSiteInfoDTO.orgIdPath
        }
        this.showButton = true
      }
    },

    handleImageChange(fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    handleRemove1() {
      this.picList1 = []
    },
    handleSuccess1(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList1 = echoFileFormat(res.data.url)
    },
    handleRemove2() {
      this.picList2 = []
    },
    handleSuccess2(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList2 = echoFileFormat(res.data.url)
    },
    handleRemove3() {
      this.picList3 = []
    },
    handleSuccess3(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList3 = echoFileFormat(res.data.url)
    },
    handleRemove4() {
      this.picList4 = []
    },
    handleSuccess4(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList4 = echoFileFormat(res.data.url)
    },
    handleRemove5() {
      this.picList5 = []
    },
    handleSuccess5(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList5 = echoFileFormat(res.data.url)
    },


    handleClick(tab, event) {
      if (tab.index == 0) {
        this.card = true
      } else {
        this.card = false
      }


    },

    areaconfirm(rows) {
      if (rows.length > 0) {

        const tableData = this.table_area;
        const map = {};
        tableData.forEach(function (item) {
          map[item.preconditionId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            preconditionId: row.id,
            areaName: row.precondition
          };
          if (!map[item.preconditionId]) {
            items.push(item);
          }
        });
        this.table_area = this.table_area.concat(items);
      }
    },
    preconditionconfirm(rows) {
      if (rows.length > 0) {

        const tableData = this.table_type;
        const map = {};
        tableData.forEach(function (item) {
          map[item.preconditionId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            preconditionId: row.id,
            typeName: row.precondition
          };
          if (!map[item.preconditionId]) {
            items.push(item);
          }
        });
        this.table_type = this.table_type.concat(items);
      }
    },
    // 删除所选的数据  2表
    handleDelete1_2(index) {
      this.tenant.snCompanyOrderAttributeDTOS.splice(index, 1);
    },
    AddListRow1_2() {

      this.tenant.snCompanyOrderAttributeDTOS.push({})
    },
    // 上传成功
    handleSuccess(response, file) {
      // 上传成功后，隐藏上传按钮
      this.upload_btn = true;
      // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
      // Vue.set(this.tenant.shopPhoto, 'pic', res.data.url)

    },
    handleRemove(response, file) {
      // 上传成功后，显示上传按钮
      // this.upload_btn = false;
    },

    handleDelete2(index) {
      this.table_area.splice(index, 1);
    },
    handleDelete(index) {
      this.table_type.splice(index, 1);
    },

    // 第一个  表格
    formatter(row, column) {
      return row.isNeedReturn == 1 ? '是' : '否'
    },
    formatter1(row, column) {
      return row.isCheck == 1 ? '是' : '否'
    },
    formatter2(row, column) {
      return row.isPast == 1 ? '是' : '否'
    },
    formatter3(row, column) {
      if (row.afterFlow == 1) {
        return "必访"
      } else if (row.afterFlow == 2) {
        return '申诉'
      } else if (row.afterFlow == 3) {
        return '挂起'
      } else if (row.afterFlow == 4) {
        return '重新完工'
      } else if (row.afterFlow == 9) {
        return '关闭'
      }

    },
    // 卡片事件
    //点击查看图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      // console.log(fileList, "已上传文件")
    },
    // 视频js
    // 视频上传


    handleRemoveVideo(file, fileList) {
      this.hideUpload = fileList.length >= this.limitCount;

      console.log(file, fileList);

    },
    handlePictureCardPreview2(file) {
      console.log(file, file.url, "99999")
      this.formData.vedioUrl = file.url;
      this.dialogVisible = true;
    },
    uploadPictureSuccess(res, file) {
      var _this = this
      if (file.status == "success") {
        _this.$message({
          message: '视频上传成功',
          type: 'success'
        })
        console.log(res, '上传成功后的res视频');
        this.formData.vedioUrl = res.data.url

      }
      // this.form.url = res.msg
      // this.formData.vedioUrl = file.url;
      // console.log( file.url," file.url的值");
      this.isShow = true

    },
    uploadPictureChange(file, fileList) {
      console.log(file, fileList)
      let _this = this
      this.hideUpload = fileList.length >= this.limitCount;
      var audioElement = new Audio(file.url), duration;
      audioElement.addEventListener("loadedmetadata", function () {
        // _this.form.time = audioElement.duration;
        // console.log('时长：' + _this.form.time + 's')
      })
    },
  },
};
</script>
<style lang="scss" scoped>
#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

el-dialog {
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
}

v::deep .el-upload .el-upload--picture-card {
  position: relative;
  left: -200px;
}

// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  >span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.firm {
  .el-input {
    width: 150px;
  }
}

.type_title {
  font-weight: 400;
  text-align: right;
  width: 112px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

.type_select {
  width: 120px;
  text-align: center;
}

.type_brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  >div {
    margin: 16px 0;
    width: 25%;
  }
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  // display:none;
  width: 0px;
  height: 0px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 60px;
  height: 60px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none !important;
}

// 输入框的宽度
// #containt .table-detail tbody tr td .el-input {
//   width: 100% !important;
//   width: 0 !important;
// }

// Switch 开关  标题的宽度
.el-switch__label * {
  line-height: 1;
  width: 160px !important;
  display: inline-block;
  font-weight: 400;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

// 清楚表格 默认padding
.el-table--medium .el-table__cell {
  padding: 0px 0 !important;
}

.table_item {
  .el-table__row:hover>td {
    background-color: #D4E7FF !important;
  }
}

.pic_item {

  .el-upload--picture-card {
    margin-top: 1px;
    width: 36px !important;
    height: 36px !important;
    line-height: 46px !important;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0 0px !important;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 5px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 380px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}


.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
  height: 60%;
}

::v-deep .el-tabs__content {
  overflow: visible !important;

}

#containt .detail-wrap .d-cont {
  overflow: unset !important;
}

// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 12px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

// 步骤条 圆的位置
::v-deep .el-timeline-item__node--normal {
  left: 0px !important;
  width: 12px;
  height: 12px;
}

.el-timeline[data-v-2cf56cc1] {
  position: relative !important;
}

#containt .detail-wrap .d-cont .d-item {
  border: solid 1px #e9e9e9;
  padding: 0 12px 6px;
  position: relative !important;
}

::v-deep .el-collapse-item__arrow {
  position: absolute !important;
  top: 12px !important;
  right: 0 !important;
  font-size: 18px;
  color: #00c4b3 !important;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0px !important;
}

// 本单费用位置
.expense {
  position: absolute;
  right: 20%;
  margin-top: 5px;
  color: #00c4b3;
  font-size: 13px;
}

::v-deep .el-image__preview {
  width: 60px !important;
  height: 60px !important;
}

.pic_main {
  display: flex;
  margin-left: 75px;
  margin-top: 10px;

  .pic_item {
    display: flex;
    margin-right: 40px;

    span {
      line-height: 60px;
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
      font-weight: 400;

    }
  }
}

// 步骤条
.el-steps--simple {
  margin: 20px 0 6px;
}

.el-step.is-simple {
  width: 225px;
}

.audit {
  span {
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
    font-weight: 400;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

// 折叠样式对其
// .table-detail {
//   tr{
//     display:block;
//   }
// }
#containt .table-detail tbody tr th {
  display: table-cell;
  vertical-align: middle;
}

#containt .table-detail tbody tr td {

  display: table-cell;
  vertical-align: middle;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}


// 字段之间的距离
#containt .table-detail tbody tr td {
  padding: 5px 12px;
  width: 172.2px;
  height: 27.2px !important;
  word-break: break-word;
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

#containt .table-detail tbody tr td {
  width: 10vw !important;
  // padding: 5px 0px!important;
  ;
}

::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}

#containt .table-detail tbody tr th {
  width: 7vw !important;
}

#containt .table-detail tbody tr td[data-v-7297c694] {
  padding: 5px 12px;
  width: 11vw !important;
  height: 27.2px !important;
  word-break: break-word;
}

::v-deep .is-success {
  position: relative;
}

::v-deep .videoUpload {
  position: relative;
}

::v-deep .avatar {
  position: absolute;
  width: 130px;
  height: 70px;
  top: -20px;
  left: 70px;
}

// ::v-deep .el-upload-list--picture-card{
//   position: absolute;
//   z-index: 999;

// }
// ::v-deep .el-upload-list--picture-card .el-upload-list__item{
//   background: transparent;
// }
/* 推荐，实现简单 */
>>>.el-upload-list__item.is-ready,
.el-upload-list__item.is-uploading {
  display: none !important;
}

::v-deep .el-upload-list__item {
  transition: none !important;
}

.amount {
  margin: 10px 0 0 200px;
  color: #00c4b3;
  font-size: 13px;
}

.videoAdd {
  width: 40px;
  height: 40px;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  text-align: center;
  line-height: 40px;

}

::v-deep .el-image {
  border: none !important;
}
.videoP{
  margin-left:10px;
  padding:5px;
  border: 1px solid #e8e8e8;
    width: 120px;
    display: flex;
    justify-content: space-between;
    border-radius:3px;
}
.imgY{
  position: absolute;
    height: 35px;
    width: 35px;
    top: 0;
    background-color: #c6c2c2;
    opacity: 0.9;
    text-align: center;
    line-height: 35px;
    font-size: 30px;
    display: none;
}
.videoImg:hover  .imgY{

    display:block

}

.rightCs {
  height: 100%;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
